// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "J\xE1 existe um layout com esse nome",
  ACCEPT: "Aceitar",
  ACCEPT_ALL: "Aceitar Tudo",
  ACCEPT_REJECT_TRANSFER_PENDING: "Aprova\xE7\xE3o Pendente",
  ACCEPTED: "Aceito",
  ACCOUNT: "Conta",
  ACCOUNT_ADDRESS: "Endere\xE7o da Conta",
  ACCOUNT_COUNTRY: "Pa\xEDs da Conta do Concession\xE1rio",
  ACCOUNT_END: "Fim da Conta",
  ACCOUNT_NAME: "Nome do Concession\xE1rio",
  ACCOUNT_NUMBER: "N\xFAmero da Conta do Concession\xE1rio",
  ACCOUNT_NUMBER_REQUIRED: "N\xFAmero da Conta \xE9 necess\xE1rio",
  ACCOUNTS: "Contas",
  ACCUMULATED_DAYS_ON_RENT: "Dias acumulados de aluguel",
  ACCUMULATED_DAYS_RENTED: "Total de Dias alugados",
  ACTIONS: "A\xE7\xF5es",
  ACTIVE_WARRANTY: "Garantia ativa",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Garantia Ativa (Clique para obter detalhes)",
  ACTUAL_AUDIT: "Auditoria efetiva",
  ACTUAL_AUDIT_DATE: "Data da Auditoria Efetiva",
  ACTUAL_COURIER_NAME: "Nome da Transportadora",
  ACTUAL_HOURS: "Horas Totais",
  ADD_CLAIM: "Adicionar reclama\xE7\xE3o",
  ADD_CLAIMS: "Adicionar reclama\xE7\xF5es",
  ADD_COMPONENT: "Adicionar Componente",
  ADD_OPTION: "Adicionar op\xE7\xE3o",
  ADD_REP: "Reparo Adicional",
  ADD_TO_AUDIT: "Adicionar \xE0 auditoria",
  ADDITIONAL: "Adicional",
  ADDITIONAL_COMMENTS: "Coment\xE1rios Adicionais",
  ADDITIONAL_REPAIR: "Reparo Adicional",
  ADDITIVE: "Aditivo",
  ADDRESS: "Endere\xE7o",
  ADDRESS_LINE1: "Linha de Endere\xE7o 1",
  ADDRESS_LINE1_REQUIRED: "Linha de Endere\xE7o 1 Necess\xE1ria",
  ADDRESS_LINE2: "Linha de Endere\xE7o 2",
  ADJ_CLM: "Ajustar Solicita\xE7\xE3o",
  ADJUST_CLAIM: "Ajustar Solicita\xE7\xE3o",
  ADJUSTED_HOURS: "Horas Ajustadas",
  ADJUSTED_QUANTITY: "Quantidade Ajustada",
  ADJUSTMENT_TYPE: "Tipo de ajuste",
  ADVANCED_CLAIM_SUMMARY: "Avan\xE7ado Resumo de Reclama\xE7\xE3o",
  AFTER_DELIVERY_INSPECTION: "INSPE\xC7\xC3O P\xD3S-ENTREGA",
  AGENCY_NAME: "Nome da Ag\xEAncia",
  ALL: "Tudo",
  ALL_ACCOUNTS: "Todas as contas",
  ALL_CLAIMS: "Todas as reclama\xE7\xF5es",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Todas as reclama\xE7\xF5es est\xE3o sujeitas a revis\xE3o (consulte JD WAM 110.08 para obter mais informa\xE7\xF5es)",
  ALL_CLAIMS_TAB: "Todas as Reclama\xE7\xF5es ({count, number})",
  ALL_PART_REQUESTS: "Solicita\xE7\xF5es de Todas as Pe\xE7as",
  ALL_PART_REQUESTS_WITH_COUNT: "Solicita\xE7\xF5es de Todas as Pe\xE7as ({count})",
  ALL_PARTS_RETURNED: "Todas Pe\xE7as Devolvidas",
  AMOUNT: "Quantidade",
  AMOUNT_1: "Quantidade 1",
  AMOUNT_2: "Quantidade 2",
  AMOUNT_3: "Quantidade 3",
  AMOUNT_OF_USE: "Quantidade de Uso",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Hist\xF3rico da Quantidade de Uso ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "Quantidade de Uso Obrigat\xF3rio",
  AMOUNT_OF_USE_REQUIRED: "Quantidade de Uso Obrigat\xF3rio",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Quantidade de unidades de uso obrigat\xF3ria",
  AMOUNT_RECORDED: "Quantidade registrada",
  AMOUNT_TO_BE_DEBITED: "Valor a ser debitado",
  APLYPIP: "Aplicar o PMP",
  APPLICATION: "Aplica\xE7\xE3o",
  APPLICATION_IS_REQUIRED: "Aplica\xE7\xE3o \xE9 Necess\xE1ria",
  APPLY: "Aplicar",
  APPLY_TRAVEL: "Aplicar Viagem",
  APPROVAL_DEALER_COMMENTS: "Coment\xE1rios de aprova\xE7\xE3o do concession\xE1rio",
  APPROVAL_DETAILS: "Detalhes da aprova\xE7\xE3o",
  APPROVAL_LELVES: "N\xEDveis de Aprova\xE7\xE3o",
  APPROVAL_REMARKS: "Observa\xE7\xF5es de Aprova\xE7\xE3o",
  APPROVAL_STATUS: "Status de Aprova\xE7\xE3o",
  APPROVE: "Aprovar",
  APPROVE_LABOR_RATE: "Aprovar pre\xE7o de m\xE3o de obra",
  APPROVE_MACHINE_STATUS_UPDATE: "Aprovar atualiza\xE7\xE3o do estado da m\xE1quina",
  APPROVE_PIP_CODE_REQUEST: "Aprovar Pedido de C\xF3digo PMP",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Aprovar Solicita\xE7\xE3o de Concess\xE3o Especial",
  APPROVED: "Aprovado",
  APPROVED_CORE_VALUE: "Valor Principal aprovado",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "A data de aprova\xE7\xE3o n\xE3o pode ser anterior \xE0 data de configura\xE7\xE3o",
  APPROVED_DIAGNOSTIC_AMOUNT: "Montante de Diagn\xF3stico Aprovado",
  APPROVED_DIAGNOSTIC_HOURS: "Horas de Diagn\xF3stico Aprovadas",
  APPROVED_IS_REQUIRED: "Aprova\xE7\xE3o \xE9 Necess\xE1ria",
  APPROVED_LABOR_ADDITIVE: "Aditivo de M\xE3o de Obra aprovado",
  APPROVED_LABOR_AMOUNT: "Quantidade de M\xE3o de Obra aprovada",
  APPROVED_LABOR_HOURS: "Horas de m\xE3o de obra aprovadas",
  APPROVED_LABOR_TOTAL: "Total de M\xE3o de Obra Aprovada",
  APPROVED_ON_SHELF_COST: "Custo final aprovado",
  APPROVED_OTHER_CREDITS: "Outros cr\xE9ditos aprovados",
  APPROVED_PARTS: "Pe\xE7as aprovadas",
  APPROVED_PARTS_ADDITIVE: "Aditivo aprovado para Pe\xE7as",
  APPROVED_PARTS_TOTAL: "Total de pe\xE7as aprovadas",
  APPROVED_REJECTED: "Aprovado/Rejeitado",
  APPROVED_REPAIR_AMOUNT: "Montante de Reparo Aprovado",
  APPROVED_REPAIR_HOURS: "Horas de Reparo Aprovadas",
  APPROVED_TAXES_TOTAL: "Total de imposto aprovado",
  APPROVED_TRAVEL_TOTAL: "Tempo total de deslocamento aprovado",
  APPROVER: "Aprovador",
  ASCENDING: "Crescente",
  ATTACHMENTS: "Acess\xF3rios",
  AUDIT_NUMBER: "N\xFAmero de Auditoria",
  AUDIT_PLANNED: "Auditoria Planejada",
  AUDIT_REQUIREMENT: "Requisito de auditoria",
  AUDIT_RESULTS: "Resultados da Auditoria",
  AUDIT_STATUS: "Status da Auditoria",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Auditoria enviada com sucesso",
  AUDIT_SUMMARY: "Resumo da auditoria",
  AUDIT_TYPE: "Tipo de auditoria",
  AUDITS: "Auditorias",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} auditoria(s) prevista(s)",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {auditoria} other {auditoria}} prevista(s) dentro de 30 dias",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {auditoria} other {auditoria}} vencida(s)",
  AUTHORIZATION_NUMBER: "N\xFAmero da Autoriza\xE7\xE3o",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Envio Autom\xE1tico do Sistema Empresarial do Concession\xE1rio",
  AVAILABLE: "Dispon\xEDvel",
  AVAILABLE_COLUMNS: "Dispon\xEDvel Colunas",
  AVERAGE_DIAGNOSTICS_HOURS: "M\xE9dia de horas de diagn\xF3stico",
  AVERAGE_LUG_HEIGHT: "Altura m\xE9dia do Peso",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "\xC9 necess\xE1ria a altura m\xE9dia do Peso",
  AVERAGE_REPAIR_HOURS: "M\xE9dia de horas de repara\xE7\xE3o",
  AVERAGE_REPLACEMENT_HOURS: "M\xE9dia de horas de substitui\xE7\xE3o",
  AVERAGE_TECH_PAY_RATE: "Taxa M\xE9dia  de Hora T\xE9cnica",
  BACK: "Voltar",
  BACK_TO_AUDIT: "Voltar \xE0 auditoria",
  BASE_MACHINE: "M\xE1quina B\xE1sica",
  BASE_MACHINE_IMPLEMENTS: "Implementos da M\xE1quina Base",
  BASE_MACHINE_PIN: "PIN da M\xE1quina Base",
  BASIC_WARRANTY_ENDS: "A Garantia B\xE1sica Vence em",
  BASIC_WARRANTY_ESTIMATOR: "Calculador de Garantia B\xE1sica",
  BASIC_WARRANTY_STARTS: "In\xEDcio da Garantia B\xE1sica",
  BASIS_FOR_SETTLEMENT: "Regulamentos do Acordo",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Regulamentos do Acordo / Coment\xE1rios de Auditoria",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Regulamentos do Acordo \xE9 Necess\xE1rio",
  BATTERY: "Bateria",
  BEGIN_DATE: "Data do In\xEDcio",
  BRANCH: "Filial",
  BUILT: "Constru\xEDdo",
  BUSINESS_END: "Fim de Neg\xF3cios",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "A m\xE1quina pode voltar a funcionar?",
  CANCEL: "Cancelar",
  CERTIFIED_LETTER_SENT: "Carta Certificada Enviada",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Concession\xE1rio Respons\xE1vel pela Troca",
  CHANGE_STATUS: "Mudar status",
  CHANGE_STATUS_FOR: "Alterar Status para {pin}",
  CHANGED: "Alterado/Trocado",
  CHANGED_BY: "Alterado/Trocado por",
  CHANGED_ON: "Trocado em",
  CHINESE: "Chin\xEAs",
  CITY: "Cidade",
  CITY_REQUIRED: "Cidade Necess\xE1ria",
  CLAIM: "Solicita\xE7\xE3o",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {solicita\xE7\xE3o} other {solicita\xE7\xF5es}})",
  CLAIM_DEBIT: "D\xE9bito da Solicita\xE7\xE3o",
  CLAIM_DETAILS: "Detalhes da solicita\xE7\xE3o",
  CLAIM_DRAFT: "RASCUNHO",
  CLAIM_HISTORY: "Hist\xF3rico de Solicita\xE7\xF5es 24 m\xEAses",
  CLAIM_HISTORY_WITH_COUNT: "Hist\xF3rico de Solicita\xE7\xF5es 24 m\xEAses ({count})",
  CLAIM_NUMBER: "N\xFAmero da Solicta\xE7\xE3o",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "Pesquisa da Solicita\xE7\xE3o",
  CLAIM_STATUS: "Status da Solicita\xE7\xE3o",
  CLAIM_TYPE: "Tipo de Solicita\xE7\xE3o",
  CLAIM_TYPES: "Tipos de Solicita\xE7\xF5es",
  CLAIM_UPDATED_SUCCESSFULLY: "Solicita\xE7\xE3o Atualizada com \xCAxito",
  CLAIM_VALUE: "Valor da Solicita\xE7\xE3o",
  CLAIM_VALUE_DETAILS: "Detalhes do Valor da Solicita\xE7\xE3o",
  CLAIM_WITH_NUMBER: "Solicita\xE7\xE3o {claimNumber}",
  CLAIMS: "Solicita\xE7\xF5es",
  CLAIMS_IN_PROGRESS: "Solicita\xE7\xF5es em Andamento",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "Solicita\xE7\xF5es em Andamento ({count})",
  CLAIMS_OVERVIEW: "Vis\xE3o geral das reclama\xE7\xF5es",
  CLAIMS_OVERVIEW_TAB: "Vis\xE3o geral das reclama\xE7\xF5es ({count})",
  CLAIMS_WITH_COUNT: "{count} Solicita\xE7\xE3o(\xF5es)",
  CLICK_FOR_DETAILS: "(Clique para ver os Detalhes)",
  CLICK_TO_VIEW_ALL: "Clique para ver tudo",
  CLOSE: "Fechar",
  CLOSED_PART_REQUESTS: "Solicita\xE7\xF5es de pe\xE7as fechadas",
  CLOSING: "Fechamento",
  CLOSING_ACCOUNT: "Fechar Conta",
  CLOSING_ACCOUNT_WITH_COUNT: "Fechando conta ({count})",
  CODE: "C\xF3digo",
  COLLAPSE_ALL: "Fechar tudo",
  COMMENT: "Coment\xE1rio",
  COMMENTS: "Coment\xE1rios",
  COMMENTS_IS_REQUIRED: "Os Coment\xE1rios s\xE3o Necess\xE1rios",
  COMMENTS_TO_DEALER: "Coment\xE1rios para o Concession\xE1rio",
  COMMON_LABOR_TYPES_WARNING: "Nem todos os tipos de m\xE3o de obra dispon\xEDveis para as contas selecionadas",
  COMPANY: "Empresa",
  COMPANY_CONTRIBUTION: "Contibui\xE7\xE3o da Companhia",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "\xC9 necess\xE1ria a contribui\xE7\xE3o da empresa",
  COMPLAINT_CAUSE: "Qual foi a Causa da Solicita\xE7\xE3o?",
  COMPLAINT_CAUSE_IS_REQUIRED: "\xC9 Necess\xE1rio Especificar a Causa da Solicita\xE7\xE3o",
  COMPLAINT_CORRECTION: "Como a Solicita\xE7\xE3o foi Corrigida?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "\xC9 necess\xE1rio fazer a corre\xE7\xE3o da Solicita\xE7\xE3o",
  COMPLETE: "Concluir",
  COMPLETED: "Completo",
  COMPLETED_BY: "Executado/Completado por",
  COMPLETED_DATE: "Data de conclus\xE3o",
  COMPLETED_IN_LAST_24_MONTHS: "Conclu\xEDdo nos \xFAltimos 24 meses",
  COMPLETION_STATUS: "Status da Finaliza\xE7\xE3o",
  COMPONENT: "Componente",
  COMPONENT_CODE: "C\xF3digo de Componente",
  COMPONENT_CREATED_SUCCESSFULLY: "Componente criado com sucesso",
  COMPONENT_DELETED_SUCCESSFULLY: "Componente exclu\xEDdo com sucesso",
  COMPONENT_SERIAL_NUMBER: "N\xFAmero de S\xE9rie do Componente",
  COMPONENT_SUCCESSFULLY_UPDATED: "Componente Atualizado com Sucesso",
  COMPONENTS: "Componentes",
  CONFIRM: "Confirmar",
  CONFIRM_ADDITIONAL_REPAIR: "Tem Certeza de que Deseja Adicionar outro Reparo?",
  CONFIRM_ADJUST_CLAIM: "Tem Certeza de que Deseja Ajustar esta Solicita\xE7\xE3o?",
  CONFIRM_CLOSING_ACCOUNT: "Tem certeza de que deseja aceitar esta transfer\xEAncia?",
  CONFIRM_COPY_CLAIM: "Tem certeza de que deseja copiar esta solicita\xE7\xE3o?",
  CONFIRM_DELETE_ATTACHMENT: "Tem certeza de que deseja excluir o arquivo anexado?",
  CONFIRM_DELETE_CLAIM: "Tem Certeza de que Deseja Excluir esta Solicita\xE7\xE3o?",
  CONFIRM_DELETE_REGISTRATION: "Tem Certeza de que Deseja excluir este Registro?",
  CONFIRM_EDIT_CLAIM: "Tem Certeza de que Deseja Editar esta Solicita\xE7\xE3o?",
  CONFIRM_RECONCILE_CLAIM: "Tem a Certeza de que Deseja Reconciliar esta Solicita\xE7\xE3o?",
  CONFIRM_RESEND_XML: "Tem certeza de que deseja reenviar XML? Por favor permitir de 24-48 horas para obter visibilidade.",
  CONFIRM_SKIP_AUDIT: "Tem certeza de que deseja pular esta auditoria?",
  CONFIRM_UNDO_REGISTRATION: "Tem certeza de que deseja desfazer este Registro?",
  CONTACTED: "Contactado",
  CONTAINS: "Cont\xE9m",
  CONTRACT_NUMBER: "N\xFAmero do Contrato",
  CONTRACT_PURCHASED: "Contrato adquirido",
  CONTRACT_TYPE: "Tipo de contrato",
  COPY_CLAIM: "Copiar Solicita\xE7\xE3o",
  CORE: "Valor",
  CORE_VALUE: "Valor da Pe\xE7a Original",
  COUNTRY: "Pa\xEDs",
  COUNTRY_REQUIRED: "Pa\xEDs Necess\xE1rio",
  COURIER_ACCOUNT_NUMBER: "N\xFAmero da Conta da Transportadora",
  COURIER_NAME: "Nome da Transportadora",
  COVERAGE_DECISION: "Decis\xE3o de Cobertura",
  COVERAGE_TYPE: "Tipo de Cobertura",
  CRDMEM: "Nota de Cr\xE9dito",
  CREATE: "Criar",
  CREATE_CLAIM: "Criar Solicita\xE7\xE3o",
  CREATE_LAYOUT: "Criar Layout",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Antes de poder criar uma Solicita\xE7\xE3o para este produto, precisamos de mais algumas informa\xE7\xF5es importantes sobre o mesmo",
  CREATE_PIP_CLAIM: "Criar Solicita\xE7\xE3o PMP",
  CREATE_PIP_CLAIMS: "Criar Solicita\xE7\xF5es de PMP",
  CREATE_PRODUCT_RECORD: "Criar registro do Produto",
  CREATE_REQUEST: "Criar Solicita\xE7\xE3o",
  CREATE_TRANSFER_PENDING: "Transfer\xEAncia Pendente",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Criar Transfer\xEAncias  de Servi\xE7o Indispon\xEDvel",
  CREATED: "Criado",
  CREATED_BY: "Criado por",
  CREATED_DATE: "Data de cria\xE7\xE3o",
  CREATED_ON: "Criado em",
  CREATION_DATE: "Data de Cria\xE7\xE3o",
  CREDIT_MEMO: "Nota de Cr\xE9dito",
  CREDIT_MEMO_DATE: "Data da Nota de Cr\xE9dito",
  CREDIT_MEMO_ISSUE_DATE: "Nota de cr\xE9dito emitida",
  CREDIT_MEMO_NUMBER: "N\xFAmero da nota de cr\xE9dito",
  CREDIT_MEMO_PROCESS_DATE: "Nota de cr\xE9dito processada",
  CREDIT_MEMO_SELECTED: "Nota de Cr\xE9dito Selecionada",
  CREDIT_MEMOS: "Notas de Cr\xE9dito",
  CRITERIA: "Crit\xE9rios",
  CRT: "Criar",
  CSV_SEPARATOR: "CSV Separator",
  CURRENCY: "Moeda",
  CURRENT: "Atual",
  CURRENT_ACCOUNT: "Conta Corrente",
  CURRENT_AMOUNT_OF_USE: "Quantidade de Uso atual",
  CURRENT_CUSTOMER: "Cliente atual",
  CURRENT_DEALER: "Concession\xE1rio Atual",
  CURRENT_DEALER_DISTANCE: "Dist\xE2ncia Atual do Concession\xE1rio",
  CURRENT_DEALER_LAST_SERVICE_DATE: "\xDAltima Data de Servi\xE7o do Concession\xE1rio Atual",
  CURRENT_DEALER_LOCATION: "Localiza\xE7\xE3o Atual do Concession\xE1rio",
  CURRENT_HOURS: "Horas atuais",
  CURRENT_QUANTITY: "Quantidade atual",
  CURRENT_RESPONSIBLE_DEALER: "Concession\xE1rio respons\xE1vel atual",
  CURRENT_VALUES: "Valores atuais",
  CURRENTLY_ON_RENT: "Atualmente Alugado",
  CUSTOM_RANGE: "Faixa de Personaliza\xE7\xE3o",
  CUSTOM_VALUES: "Valores personalizados",
  CUSTOMER: "Cliente",
  CUSTOMER_CONTRIBUTION: "Contibui\xE7\xE3o do Cliente",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "\xC9 necess\xE1ria a contribui\xE7\xE3o do cliente",
  CUSTOMER_CREATED_SUCCESSFULLY: "Cliente criado com \xEAxito",
  CUSTOMER_DETAILS: "Detalhes do Cliente",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Detalhes do cliente atualizados com \xEAxito",
  CUSTOMER_INFORMATION: "Informa\xE7\xE3o ao Cliente",
  CUSTOMER_INFORMATION_IS_REQUIRED: "A informa\xE7\xE3o do cliente \xE9 necess\xE1ria.",
  CUSTOMER_INVALID: "Cliente inv\xE1lido, por favor tente novamente",
  CUSTOMER_NAME: "Nome do cliente",
  CUSTOMER_NAME_IS_REQUIRED: "A informa\xE7\xE3o do cliente \xE9 necess\xE1ria.",
  CUSTOMER_NOT_FOUND: "Cliente n\xE3o encontrado",
  CUSTOMER_PROFILE: "Perfil do Cliente",
  CUSTOMER_REQUIRED: "Cliente obrigat\xF3rio",
  CUSTOMER_RESOLUTION: "Resolu\xE7\xE3o do cliente",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "\xC9 necess\xE1ria a resolu\xE7\xE3o do cliente",
  CUSTOMER_SEARCH: "Pesquisa de cliente",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Cliente atualizado com \xEAxito",
  DAMAGED_MACHINES_HELP_TEXT: "Para m\xE1quinas danificadas, a garantia ser\xE1 automaticamente suspensa at\xE9 que este formul\xE1rio seja analisado e aprovado pelo TCSM para readmitir a garantia. M\xE1quinas danificadas se enquadram somente em PIPs de Seguran\xE7a e Obrigat\xF3rio.",
  DATE: "Data",
  DATE_FORMAT: "Formato de Data",
  DATE_ISSUED: "Data Emitida",
  DATE_OF_CERTIFIED_LETTER: "Data da carta registrada",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Data do evento que causou o dano",
  DATE_OF_LAST_PERSONAL_CONTACT: "Data do \xFAltimo contato pessoal",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Data que a pe\xE7a recall foi enviada",
  DATE_REFUSED: "Data Recusada",
  DATE_SUBMITTED: "Data de Envio",
  DAYS_FROM_REGISTRATION: "Dias do Registro",
  DAYS_LEFT: "Dias Restantes",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {dia restante} other {dias restantes}}",
  DAYS_ON_RENT: "Dias Alugados",
  DAYS_REMAINING: "Dias restantes",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {dia} other {dias}} restante(s)",
  DAYS_TO_DISPLAY: "Dias para exibir",
  DBS: "SEC",
  DEALER: "Concession\xE1rio",
  DEALER_ACCOUNT: "Conta do concession\xE1rio",
  DEALER_ACCOUNT_IS_REQUIRED: "\xC9 necess\xE1ria a conta do concession\xE1rio",
  DEALER_ACCOUNTS: "N\xFAmero das Contas do Concession\xE1rio",
  DEALER_CITY: "Cidade do Concession\xE1rio",
  DEALER_COMMENTS: "Coment\xE1rios do Concession\xE1rio",
  DEALER_CONTRIBUTION: "Contribui\xE7\xE3o do Concession\xE1rio",
  DEALER_CONTRIBUTION_IS_REQUIRED: "\xC9 necess\xE1ria a contribui\xE7\xE3o do concession\xE1rio",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "N\xFAmero da Fatura do Concession\xE1rio",
  DEALER_INVOICE_UPDATED: "Fatura do concession\xE1rio atualizada",
  DEALER_INVOICE_UPDATES: "Fatura do concession\xE1rio",
  DEALER_INVOICES: "Faturas do Concession\xE1rio",
  DEALER_LOCATION: "Localiza\xE7\xE3o do concession\xE1rio",
  DEALER_LOCATION_FILTER: "Filtrar localiza\xE7\xF5es",
  DEALER_LOCATION_IS_REQUIRED: "\xC9 necess\xE1ria a localiza\xE7\xE3o do concession\xE1rio",
  DEALER_LOCATIONS: "Localiza\xE7\xF5es dos concession\xE1rios",
  DEALER_NAME: "Nome do Concession\xE1rio",
  DEALER_PHONE: "N\xBA de Tefefone do Concession\xE1rio",
  DEALER_POSTAL_CODE: "C\xF3digo Postal",
  DEALER_RECOMMENDATIONS: "Recomenda\xE7\xF5es do Concession\xE1rio",
  DEALER_RECOMMENDATIONS_TAB: "Recomenda\xE7\xF5es do Concession\xE1rio ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "Revisado com Sucesso pelo Concession\xE1rio",
  DEALER_SEARCH: "Pesquisa de Concession\xE1rio",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Insira o Nome, Cidade ou Conta para pesquisar por concession\xE1rios",
  DEALER_STATE: "Estado do Concession\xE1rio",
  DEALER_SUBMISSION_WITH_CURRENCY: "Envio do concession\xE1rio ({currency})",
  DEALER_TRANSFER_HISTORY: "Hist\xF3rico de Transfer\xEAncia do Concession\xE1rio",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Solicita\xE7\xE3o de Transfer\xEAncia do Concession\xE1rio Enfileirada com Sucesso",
  DEALER_WARRANTY: "Garantia do Concession\xE1rio",
  DEALERS: "Concession\xE1rios",
  DEALERSHIP: "Concession\xE1ria",
  DEBIT: "D\xE9bito",
  DEBIT_AMOUNT: "Valor do d\xE9bito",
  DEBIT_FOR_CLAIM_NUMBER: "D\xE9bito para {claimNumber}",
  DEBIT_REQUIRED: "D\xE9bito obrigat\xF3rio",
  DEBIT_REQUIRED_STATUS: "Status do d\xE9bito \xE9 necess\xE1rio",
  DEBIT_SUBMITTED_SUCCESSFULLY: "D\xE9bito enviado com sucesso",
  DEBIT_TYPE: "Tipo de d\xE9bito",
  DEBITED: "Debitado",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Os d\xE9bitos para esta solicita\xE7\xE3o devem ser conclu\xEDdos atrav\xE9s do processo de d\xE9bito manual",
  DECIMAL_FORMAT: "Formato Decimal",
  DECISION_UPDATED: "Decis\xE3o Atualizada",
  DECLINE: "Recusar",
  DEDUCTIBLE: "Dedut\xEDvel",
  DEERE_REMARKS: "Observa\xE7\xF5es da Deere",
  DEFAULT_WARRANTY: "Garantia Padr\xE3o",
  DEL: "Excluir",
  DELETE: "Excluir",
  DELETE_ATTACHMENT: "Excluir anexo",
  DELETE_CLAIM: "Excluir Solicita\xE7\xE3o",
  DELETE_REGISTRATION: "Excluir Registro",
  DELETE_REGISTRATION_SUCCESS: "Exclus\xE3o do Registro Realizada com Sucesso",
  DELETED: "Exclu\xEDdo",
  DELETED_BY: "Exclu\xEDdo por",
  DELIVERED: "Entregue",
  DELIVERED_IS_REQUIRED: "\xC9 necess\xE1ria a entrega",
  DELIVERY_DATE: "Data de Entrega",
  DELIVERY_DATE_REQUIRED: "Requer data de entrega",
  DELIVERY_DATES: "Datas de Entrega",
  DELIVERY_NO_DOCUMENTS: "Entregue, Nenhum Documento",
  DEMO_RENTAL_BEGIN_DATE: "Demonstra\xE7\xE3o/Data de in\xEDcio do aluguel",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Selecionar Concession\xE1rios e Status",
  DEMO_RENTAL_END_DATE: "Demonstra\xE7\xE3o/Data final do aluguel",
  DEMO_RENTAL_HISTORY: "Hist\xF3rico do aluguel  da Demonstra\xE7\xE3o",
  DENY: "Rejeitar",
  DENY_MACHINE_STATUS_UPDATE: "Rejeitar atualiza\xE7\xE3o do status da m\xE1quina",
  DENY_PIP_CODE_REQUEST: "Rejeitar pedido de c\xF3digo PMP",
  DESCENDING: "Decrescente",
  DESCRIPTION: "Descri\xE7\xE3o",
  DESCRIPTION_OF_DAMAGE: "Descri\xE7\xE3o do dano",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Descri\xE7\xE3o do evento que causou o dano",
  DESELECT_ALL: "Cancelar Sele\xE7\xE3o de Tudo",
  DETAILS: "Detalhes",
  DIAGNOSTICS_COVERED: "Diagn\xF3sticos abrangidos",
  DIS_VSR: "Exibir Mensagens",
  DISPLAY: "Exibi\xE7\xE3o",
  DISPLAY_CLAIM: "Exibir solicita\xE7\xE3o",
  DISPLAY_CREDIT_MEMO: "Exibir nota de cr\xE9dito",
  DISPLAY_FORMAT: "Formato de Exibi\xE7\xE3o",
  DISPLAY_PRODUCT: "Exibir Produto",
  DISPLAY_TAG: "Exibir Etiqueta",
  DISTANCE: "Dist\xE2ncia",
  DISTANCE_FROM_CURRENT_DEALER: "Dist\xE2ncia do Concession\xE1rio Atual",
  DISTANCE_FROM_POTENTIAL_DEALER: "Dist\xE2ncia do Concession\xE1rio em Potencial",
  DIVISION: "Divis\xE3o",
  DIVISION_SUMMARY: "Resumo da Divis\xE3o",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Salvar altera\xE7\xF5es?",
  DOES_NOT_CONTAIN: "N\xE3o cont\xE9m",
  DOWNLOAD_TO_EXCEL: "Baixar para o Excel",
  DOWNTIME: "Tempo da M\xE1quina Parada",
  DOWNTIME_IS_REQUIRED: "Tempo de m\xE1quina parada \xE9 necess\xE1rio",
  DRAFT: "Salvar como Rascunho",
  DTAC_CASE: "Caso DTAC",
  DTAC_CASE_NUMBER: "N\xFAmero do caso DTAC",
  DTAC_SOLUTION: "Solu\xE7\xE3o DTAC",
  DUE_DATE: "Data prevista",
  DUE_WITHIN_3_MONTHS: "Previsto dentro de 3 meses",
  DUPLICATE_PIN_PLATE: "Placa do PIN Duplicada",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Solicita\xE7\xE3o de Placa do PIN Duplicada Atualizada",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Solicita\xE7\xE3o de Placa PIN Duplicada Criada com \xCAxito",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Solicita\xE7\xE3o de Placa do PIN Duplicada ({count})",
  EDIT: "Editar",
  EDIT_CUSTOMER: "Editar Cliente",
  EDIT_LAYOUT: "Editar Layout",
  EDIT_WITH_PARENTHESES: "(Editar)",
  EFFECTIVE: "Efetivo",
  EFFECTIVE_DATE: "Data de vig\xEAncia",
  EMAIL: "E-mail",
  EMISSIONS_PART_SEARCH: "Pesquisa de Pe\xE7as de Emiss\xF5es",
  END_DATE: "Data Final",
  END_USE: "Uso Final",
  END_USE_CODE: "C\xF3digo de uso Final",
  END_USE_CODE_REQUIRED: "C\xF3digo de Uso Final obrigat\xF3rio",
  ENDS_WITH: "Termina com",
  ENGLISH: "Ingl\xEAs",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Insira um n\xFAmero entre 0 a 1000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Insira um n\xFAmero entre 0 e 10 000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Insira um n\xFAmero de 1 a 9999",
  ENTER_A_PART_NUMBER: "Insira o N\xFAmero da pe\xE7a",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Insira coment\xE1rios antes de aceitar",
  EQUALS: "\xC9 igual a",
  ERROR: "ERRO:",
  ERROR_MESSAGE_TITLE: "Ocorreu um erro:",
  ERROR_MESSAGES: "Mensagem de Erro",
  ERROR_MESSAGES_TITLE: "Ocorreram v\xE1rios erros:",
  ERROR_NETWORK_ISSUES: "Um erro de Rede fez com que alguns dados n\xE3o fossem carregados. Por favor, Tente novamente.",
  ERROR_NO_DATA_TO_EXPORT: "Sem dados para exportar",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Erro ao recuperar informa\xE7\xF5es do cliente",
  ERROR_SAP: "N\xE3o \xE9 poss\xEDvel se conectar ao Servidor. Se o problema persistir, utilize o link \"Contacte-nos\" para obter assist\xEAncia na resolu\xE7\xE3o do seu problema.",
  ERROR_SESSION: "A sua sess\xE3o expirou. Atualize a p\xE1gina para voltar a iniciar sess\xE3o.",
  ERROR_UNHANDLED: "O sistema detetou um erro inesperado. Se o problema persistir, utilize a fun\xE7\xE3o \"Ajuda\" ou o link \"Contacte-nos\" para obter assist\xEAncia na resolu\xE7\xE3o do seu problema.",
  ERROR_UPLOADING_FILE: "O Arquivo n\xE3o foi adicionado",
  ESTIMATED_BASIC_DATE: "Data B\xE1sica Estimada",
  ESTIMATED_BASIC_DAYS: "Dias B\xE1sicos Estimados",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "As estimativas podem n\xE3o refletir o status de demonstra\xE7\xE3o ou as horas ainda n\xE3o relatadas",
  EXCEEDS_DEMO_THRESHOLD: "Excede o Limite de Demonstra\xE7\xE3o",
  EXCHANGE_RATE: "Taxa de c\xE2mbio",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "PINs exclu\xEDdos n\xE3o est\xE3o inclu\xEDdos neste relat\xF3rio.",
  EXECUTE: "Executar",
  EXPAND_ALL: "Expandir tudo",
  EXPECTED_FIRST_USE: "Data esperada do primeiro uso",
  EXPIRATION_DATE: "Data de Expira\xE7\xE3o",
  EXPIRED: "Expirado",
  EXPIRED_PART_REQUESTS: "Solicita\xE7\xF5es de pe\xE7as expiradas",
  EXPIRED_PIPS: "PMPs Expirado",
  EXPIRES: "Expira\xE7\xF5es",
  EXPIRING_SOON: "Expirando em Breve",
  EXPORT: "Exportar",
  EXTENDED_WARRANTY: "Garantia Estendida",
  FACTORY: "F\xC1BRICA",
  FACTORY_NAME: "Nome da F\xE1brica",
  FAILED: "Falhou",
  FAILED_AREA: "\xC1rea que falhou",
  FAILED_AREA_IS_REQUIRED: "\xC9 necess\xE1ria a \xE1rea da falha",
  FAILED_DATE: "Data da falha",
  FAILED_DATE_IS_REQUIRED: "\xC9 necess\xE1ria a data da falha",
  FAILED_MODE: "Modo da Falha",
  FAILED_MODE_COMMENTS: "Coment\xE1rios do Modo da Falha",
  FAILED_PART: "Pe\xE7a com falha",
  FAILED_PART_DESCRIPTION: "Descri\xE7\xE3o da Pe\xE7a com falha",
  FAILED_PART_IS_A_REMAN_PART: "Pe\xE7a com falha \xE9 uma parte do ReMan",
  FAILED_PART_IS_REQUIRED: "\xC9 necess\xE1ria a pe\xE7a com falha",
  FAILED_PART_SERIAL: "S\xE9rie da pe\xE7a com falha",
  FAILED_PART_SERIAL_IS_REQUIRED: "\xC9 necess\xE1ria a s\xE9rie da pe\xE7a com falha",
  FAILURE_DATE: "Data da Falha",
  FAILURE_INFORMATION: "Informa\xE7\xE3o da Falha",
  FAILURE_MODE: "C\xF3digo da Falha",
  FAILURE_MODE_IS_REQUIRED: "\xC9 necess\xE1rio o Modo da Falha",
  FAILURE_PART: "Pe\xE7a com falha",
  FAILURE_PART_DESCRIPTION: "Descri\xE7\xE3o da Pe\xE7a com falha",
  FAILURE_PART_IS_REQUIRED: "\xC9 necess\xE1ria a pe\xE7a com falha",
  FAILURE_TO_RETURN_PARTS_WARNING: "N\xE3o devolver as partes solicitadas pode resultar em um d\xE9bito.",
  FAVORITES: "Favoritos",
  FILE_NAME: "Nome do Arquivo",
  FILE_SIZE_IS_TOO_BIG: "O arquivo \xE9 demasiado grande (tamanho m\xE1ximo 100 MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "O arquivo \xE9 demasiado grande (tamanho m\xE1ximo 1 MB)",
  FILE_UPLOAD_MESSAGE: "Libere os  arquivos aqui ou clique para adicionar arquivos (tamanho m\xE1ximo 100 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Libere os  arquivos aqui ou clique para adicionar arquivos (tamanho m\xE1ximo 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Libere as imagens aqui ou clique para adicionar imagens (tamanho m\xE1ximo 100 MB)",
  FILE_UPLOAD_MESSAGE_SINGLE: "Arraste um \xFAnicoarquivo  aqui ou clique em adicionar (tamanho m\xE1ximo 100 MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "O sistema n\xE3o p\xF4de ler seu arquivo.  Compare-o com o modelo e tente novamente.",
  FILES: "Arquivos",
  FILTER_PLACEHOLDER: "Filtrar resultados",
  FILTER_WITH_ELLIPSIS: "Filtrar...\"",
  FILTERED_BY_COLUMN_ID: "Filtrado por {columnId}",
  FIND_CUSTOMER: "Encontre o Cliente",
  FINNISH: "Finland\xEAs",
  FIRST_MAINTENANCE: "PRIMEIRA MANUTEN\xC7\xC3O",
  FIRST_NAME: "Primeiro Nome",
  FIRST_NAME_IS_REQUIRED: "\xC9 necess\xE1rio o nome pr\xF3prio",
  FIRST_SHIP_TO_LOCATION: "Primeiro envio para o local",
  FIRST_USE: "Usado pela primeira vez",
  FISCAL_YEAR: "Ano fiscal",
  FLUID_SAMPLING_REQUIRED: "\xC9 necess\xE1ria uma amostra de flu\xEDdo",
  FORWARDED: "Encaminhado",
  FRENCH: "Franc\xEAs",
  FROM: "De",
  FRWRD: "Enviar",
  FULL_DEBIT: "D\xE9bito Total",
  GENERAL: "Geral",
  GERMAN: "Alem\xE3o",
  GET_MAINTENANCE_PLANS: "Obter planos de manuten\xE7\xE3o",
  GOODS_INSTALLATION_VAT: "IVA da instala\xE7\xE3o de produtos",
  GRACE_PERIOD: "Per\xEDodo de Gracias",
  GREATER_THAN: "Melhor que",
  GREATER_THAN_OR_EQUALS: "Melhor que ou igual",
  GROUP_COMPLETE: "Grupo Completo",
  GST_PERCENTAGE: "GST Porcentagem",
  HISTORY_TO_DISPLAY: "Mostrar Hist\xF3rico (dias)",
  HOME: "Principal",
  HOUR_LIMIT: "Limite de horas",
  HOURS: "Horas",
  HOURS_ON_RENT: "Horas de aluguel",
  HSN_SAC_CODE: "HSN/SAC C\xF3digo",
  IGST: "IGST",
  IMPLEMENTS: "Implementos",
  IN_RANGE: "No Alcance",
  INCENTIVE: "Incentivo",
  INCENTIVE_PROGRAMS: "Programas de incentivo",
  INCLUDE_FULLY_COMPLETE: "Incluir PIPs Completamente Completos",
  INDICATES_REQUIRED_FIELD: "Indica um campo obrigat\xF3rio",
  INFO_MESSAGE_TITLE: "Foi enviada uma notifica\xE7\xE3o do Sistema:",
  INFO_MESSAGES: "Mensagens de informa\xE7\xE3o",
  INFO_MESSAGES_TITLE: "Foram enviadas v\xE1rias notifica\xE7\xF5es do sistema:",
  INFO_REQUEST_STATUS_ERROR: "As informa\xE7\xF5es est\xE3o prontas para serem enviadas com essa solicita\xE7\xE3o.",
  INFORMATION: "Em forma\xE7\xE3o",
  INFORMATION_REQUEST: "Solicita\xE7\xE3o de Informa\xE7\xF5es",
  INFORMATION_REQUEST_STATUS: "Status da Solicita\xE7\xE3o de Informa\xE7\xF5es",
  INPUT_PIN: "Introduzir PIN",
  INSPECTION: "Inspe\xE7\xE3o",
  INSTALLED_BY: "Instalado por",
  INSTALLED_BY_IS_REQUIRED: "\xC9 necess\xE1ria a informa\xE7\xE3o do respons\xE1vel pela instala\xE7\xE3o",
  INTERNAL_DEERE_COMMENTS: "Coment\xE1rios Internos Deere",
  INTERVAL_BEGINS: "In\xEDcio do Intervalo",
  INTERVAL_ENDS: "Fim do Intervalo",
  INTERVAL_TYPE_DESCRIPTION: "Descri\xE7\xE3o do Tipo de Intervalo",
  INVOICE_ACCOUNT: "Conta de Fatura",
  INVOICE_DEALER: "Fatura do Concession\xE1rio",
  INVOICE_NUMBER: "N\xFAmero da Fatura",
  INVOICE_REQUEST: "Pedido de fatura",
  INVOICE_SENT: "Fatura enviada",
  INVOICE_UPDATED_SUCCESSFULLY: "Atualiza\xE7\xE3o de faturas com sucesso",
  INVOICED: "Faturado",
  INVOICED_TO: "Faturado para",
  IRC_PIN_MESSAGE: "O cliente \xE9 um IRC e tem o direito a um tempo de deslocamento e quilometragem complementares pelas primeiras 500 horas ou 12 meses de propriedade da m\xE1quina.",
  ISSUED: "Emitido",
  ITALIAN: "Italiano",
  ITEM: "Item",
  ITEM_NUMBER: "N\xFAmero do item",
  ITEM_NUMBER_IS_REQUIRED: "\xC9 necess\xE1rio o N\xFAmero do \xCDtem",
  JDLINK_EXPIRES: "JDLink Expira",
  JDP_COMMENTS: "JDP Coment\xE1rios",
  JDP_COMMENTS_IS_REQUIRED: "S\xE3o necess\xE1rios os coment\xE1rios JDP",
  JDP_CUSTOMER_RESOLUTION: "Resolu\xE7\xE3o do Cliente JDP",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "\xC9 necess\xE1ria a resolu\xE7\xE3o do cliente JDP",
  JDP_REASON: "Motivo JDP",
  JDP_REASON_IS_REQUIRED: "\xC9 necess\xE1rio o motivo JDP",
  LABOR: "M\xE3o de Obra",
  LABOR_ADDITIVE: "Suplemento de m\xE3o de Obra",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Detalhe de Conclus\xE3o do Aditivo de Trabalho",
  LABOR_ADDITIVE_PIPS: "M\xE3o de Obra - Aditivos PMPs",
  LABOR_ADDITIVE_TAB: "Aditivo de M\xE3o de Obra ({count})",
  LABOR_ADJUSTMENT: "Ajuste de m\xE3o de obra",
  LABOR_COMMENTS: "Coment\xE1rios de M\xE3o de Obra",
  LABOR_HOURS: "M\xE3o de Obra",
  LABOR_ITEM_DETAILS: "M\xE3o de Obra - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Valor de M\xE3o de Obra aprovado com sucesso",
  LABOR_RATE_CHANGE_SUBMITTED: "Altera\xE7\xE3o do valor  de M\xE3o de Obra enviada",
  LABOR_RATE_CHANGES_WITH_COUNT: "Altera\xE7\xF5es do valor de M\xE3o de Obra ({count})",
  LABOR_RATE_CONFIRM: "O pre\xE7o solicitado \xE9 inferior aos pre\xE7o atual. Tem a certeza de que pretende submeter o Pedido?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "Taxas no texto vermelho indicam aumento de mais de 10% da taxa existente",
  LABOR_RATE_HISTORY: "Hist\xF3rico da valor de m\xE3o de obra",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Valor de M\xE3o de Obra rejeitado com sucesso",
  LABOR_RATE_REQUESTS_STATUS: "Status de Solicita\xE7\xF5es da Taxa de M\xE3o de Obra",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Taxa de m\xE3o de obra retornada com sucesso",
  LABOR_RATES: "Valores de m\xE3o de obra",
  LABOR_STATS: "Estat\xEDsticas de m\xE3o de obra",
  LABOR_TOTAL: "Total de M\xE3o de Obra",
  LABOR_TYPE: "Tipo de m\xE3o de obra",
  LABOR_VALUE: "Valor da m\xE3o de obra",
  LABOR_WITH_COUNT: "Trabalho ({count})",
  LANGUAGE: "Idioma",
  LAST_LOCATION_FROM: "\xDAltimo Local de",
  LAST_NAME: "Sobrenome",
  LAST_NAME_IS_REQUIRED: "\xC9 necess\xE1rio o Sobrenome",
  LAST_PERSONAL_CONTACT: "\xDAltimo Contato Pessoal",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Detalhes da Ag\xEAncia de aplica\xE7\xE3o da Lei",
  LAYOUT_CREATED_SUCCESSFULLY: "Layout criado com sucesso",
  LAYOUT_DELETED_SUCCESSFULLY: "Layout apagar com Sucesso",
  LAYOUT_NAME: "Nome de layout",
  LAYOUT_UPDATED_SUCCESSFULLY: "Layout atualizado com sucesso",
  LEAD_ACCOUNT: "Conta L\xEDder",
  LEAD_DEALER: "Concession\xE1rio L\xEDder",
  LESS_THAN: "Menos que",
  LESS_THAN_OR_EQUALS: "Menor ou igual",
  LICENSE_PLATE_NUMBER: "N\xFAmero da Placa de Licenciamento",
  LIFETIME: "Garantia Vital\xEDcia",
  LINE_ITEMS_EXPORT: "Exporta\xE7\xE3o de itens de linha",
  LIST: "Lista",
  LIST_TOTAL: "Total da lista",
  LOCATION: "Local",
  LOCATION_DUE: "Localiza\xE7\xE3o prevista",
  LOCATIONS: "Locais",
  LOCATIONS_WITH_COUNT: "Localiza\xE7\xF5es ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "A m\xE1quina j\xE1 est\xE1 registada para este cliente",
  MACHINE_INFORMATION: "Informa\xE7\xE3o da M\xE1quina",
  MACHINE_MODEL_TYPE: "Modelo/Tipo de M\xE1quina",
  MACHINE_MODEL_TYPE_REQUIRED: "Modelo/Tipo de M\xE1quina Necess\xE1rio",
  MACHINE_STATUS: "Status da M\xE1quina",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Atualiza\xE7\xE3o do status da M\xE1quina aprovada",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Documento de atualiza\xE7\xE3o do status da M\xE1quina",
  MACHINE_STATUS_UPDATE_REJECTED: "Atualiza\xE7\xE3o do status da M\xE1quina rejeitada",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Atualiza\xE7\xF5es do status da M\xE1quina ({count})",
  MACHINE_TYPE: "Tipo da M\xE1quina",
  MACHINE_TYPE_IS_REQUIRED: "\xC9 necess\xE1rio o tipo de m\xE1quina",
  MACHINE_USE: "Uso da M\xE1quina",
  MAILING_RECIPIENT: "Destinat\xE1rio para Correspond\xEAncia (Nome e Sobrenome)",
  MAILING_RECIPIENT_REQUIRED: "Destinat\xE1rio para Correspond\xEAncia Necess\xE1rio",
  MAINTENANCE: "Manuten\xE7\xE3o",
  MAINTENANCE_PLAN: "Planos de Manuten\xE7\xE3o",
  MAINTENANCE_PLAN_INFO: "Informa\xE7\xF5es do Plano de Manuten\xE7\xE3o",
  MARK_AS_REVIEW: "Marque como Revisado",
  MARKETING_INCENTIVE: "Marketing \u2014 Incentivo",
  MARKETING_JD_PROMISE: "Marketing \u2013 Compromisso da JD",
  MARKETING_MAINTENANCE_PLAN: "Marketing \u2013 Plano de manuten\xE7\xE3o",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marketing \u2013 Acompanhamento do canal de grande volume",
  MARKETING_MASS_CHANNEL_PDI: "Marketing \u2013 Canal de grande volume PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Acompanhamento do Cliente do com\xE9rcio de auto-servi\xE7o massivo",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Lembrete. Por favor,  entre em contato com seu pr\xF3prio Representante Legal para determinar os apropriados #Do Not Call# procedimentos dentro do seu Estado e das Autoridades Legais antes de implementar o Programa de Chamada de Acompanhamento P\xF3s-venda",
  MASS_CHANNEL_PDI_CLAIM: "Canal de grande volume PDI",
  MASTER_WARRANTY_TYPE: "Tipo de Garantia Principal",
  MATERIAL: "N\xFAmero do Material",
  MERCHANDISE: "Mercadorias",
  MESSAGE: "Mensagem",
  MESSAGES: "Mensagens",
  METHOD_OF_CONTACT: "M\xE9todo de Contato",
  METHOD_OF_CONTACT_IS_REQUIRED: "\xC9 necess\xE1rio o m\xE9todo de contacto",
  METRIC: "M\xE9trica",
  METRICS: "M\xE9tricas",
  MILEAGE_LIMIT: "Limite de Milhagem",
  MOBILE_PHONE: "Telefone M\xF3vel",
  MODEL: "Modelo",
  MODEL_NUMBER: "N\xFAmero do Modelo",
  MODIFIED: "Modificado",
  MONTH_TO_DATE: "M\xEAs at\xE9 a Data",
  MORE: "Mais",
  MULTIPLE: "M\xFAltiplos",
  NAME: "Nome",
  NET: "L\xEDquido",
  NET_AMOUNT: "Montante l\xEDquido",
  NET_AMOUNT_PAID: "Montante l\xEDquido pago",
  NET_TOTAL: "Total L\xEDquido",
  NEW: "Novo",
  NEW_ACCOUNT: "Nova Conta",
  NEW_CLAIM: "Nova solicita\xE7\xE3o",
  NEW_CLAIM_VALUE: "Valor da Nova Solicita\xE7\xE3o",
  NEW_CUSTOMER_REQUIRED: "Novo Cliente obrigat\xF3rio",
  NEW_DEALER: "Novo Concession\xE1rio",
  NEW_DEALER_DISTANCE: "Nova Dist\xE2ncia do Concession\xE1rio",
  NEW_DEALER_LOCATION: "Nova Localiza\xE7\xE3o do Concession\xE1rio",
  NEW_LABOR_RATE: "Novo pre\xE7o de m\xE3o de obra",
  NEW_REQUEST_ENTER_RATES: "Nova Solicita\xE7\xE3o - Inserir Taxas",
  NEW_STATUS: "Novo Status",
  NEW_TRANSFER: "Nova Transfer\xEAncia",
  NEW_TRANSFER_CREATED: "Nova Transfer\xEAncia Criada",
  NEW_VALUE: "Novo valor",
  NO: "N\xE3o",
  NO_ACTIVE_WARRANTY: "Nenhuma Garantia Ativa",
  NO_AFFECTED_PINS: "N\xE3o existem PINs afetados sob a responsabilidade do seu concession\xE1rio",
  NO_AUTHORITY_TO_ACCESS: "Voc\xEA n\xE3o tem autoridade para acessar o JDWS. Usu\xE1rios do concession\xE1rio, favor acompanhar o Administrador de Perfil (DPA) para verificar se a autoridade e os usu\xE1rios da Deere entram em contato com o Suporte com uma c\xF3pia desse erro aqui",
  NO_CLAIMS: "N\xE3o existem Solicita\xE7\xF5es",
  NO_CUSTOMER_ASSOCIATED: "Nenhum Cliente Associado",
  NO_CUSTOMER_SELECTED: "Nenhum cliente selecionado",
  NO_DEALER_INVOICES: "Nenhuma fatura do concession\xE1rio",
  NO_DEALERS_MAPPED: "N\xE3o existem Concession\xE1rios mapeados para a sua ID de usu\xE1rio. Por favor, contate o Administrador do Sistema.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "N\xE3o (nesse caso, forne\xE7a uma imagem como evid\xEAncia)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Nenhuma informa\xE7\xE3o dispon\xEDvel para este Produto",
  NO_LOWERCASE: "N\xE3o",
  NO_MATCHING_DEALERS: "Nenhum dos concession\xE1rios corresponde ao texto do filtro.",
  NO_OPEN_PART_REQUESTS: "Nenhum solicita\xE7\xF5es de pe\xE7a aberta",
  NO_OPEN_PIPS: "Nenhum PMP aberto",
  NO_PARTS_RETURNED: "Nenhuma pe\xE7a devolvida",
  NO_PIP_PRODUCTS: "N\xE3o h\xE1 produtos PMP.",
  NO_PRODUCT_FOUND: "Nenhum Produto Encontrado",
  NO_REQUIRED_ITEMS: "N\xE3o h\xE1 itens obrigat\xF3rios.",
  NO_RESULTS: "Sem resultados",
  NO_RESULTS_FOUND: "N\xE3o Foi Encontrado Nenhum Resultado",
  NO_ROWS_TO_SHOW: "Sem linhas para mostrar",
  NO_SPECIAL_INSTRUCTIONS: "N\xE3o h\xE1 instru\xE7\xF5es obrigat\xF3rias.",
  NO_TRAVEL: "Nenhum Deslocamento",
  NON_RECOVERABLE_TAXES: "Impostos N\xE3o Recuper\xE1veis",
  NON_TRACKED_PINS_HELP_TEXT: "Alguns Produtos n\xE3o aparecem na Garantia at\xE9 terem sido registrados. A sua pesquisa refere-se a este Produto",
  NON_TRAVEL: "Sem Viagem",
  NONE: "Nenhum",
  NORMAL: "NORMAL",
  NOT_EQUAL: "N\xE3o igual",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Notifica\xE7\xE3o adicionada com sucesso",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Notifica\xE7\xE3o exclu\xEDda com sucesso",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Sequ\xEAncia de notifica\xE7\xE3o atualizada com sucesso",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Notifica\xE7\xE3o atualizada com sucesso",
  NOTIFICATIONS: "Notifica\xE7\xF5es",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "N\xFAmero de ocorr\xEAncias de diagn\xF3sticos",
  NUMBER_OF_OPEN_PIPS: "{number} PMP aberto(s)",
  NUMBER_OF_REPAIR_OCCURRENCES: "N\xFAmero de ocorr\xEAncias de repara\xE7\xF5es",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "N\xFAmero de ocorr\xEAncias de substitui\xE7\xF5es",
  OLD_LABOR_RATE: "Pre\xE7o de m\xE3o de obra antigo",
  ON_SHELF: "Na prateleira",
  ON_SHELF_COST: "Custo posto na prateleira",
  ONE_ITEM_MUST_BE_SELECTED: "\xC9 necess\xE1rio selecionar uma op\xE7\xE3o",
  OPEN: "Abrir",
  OPEN_PART_REQUESTS: "Pedidos de pe\xE7a(s) abertos",
  OPEN_PART_REQUESTS_WITH_COUNT: "Pedidos de Pe\xE7a(s) Abertos ({count})",
  OPEN_PIP_COUNT: "Contagem de PIP aberta",
  OPEN_PIP_PROGRAMS: "Registro de PMP",
  OPEN_PIPS: "Abrir PMP",
  OPEN_PIPS_REPORT: "Relat\xF3rio de PMP incompleto",
  OPEN_PIPS_TAB: "Abrir PMPs ({count})",
  OPERATORS_COMPLAINT: "Qual foi a reclama\xE7\xE3o do operador?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "\xC9 necess\xE1rio ter a reclama\xE7\xE3o do operador",
  OPERATORS_MANUAL_NUMBER: "Numero do manual do operador",
  OPTION_CODES: "C\xF3digo de Op\xE7\xF5es",
  OR: "ou",
  ORIGINAL_CLAIM_VALUE: "Valor da Solicita\xE7\xE3o Original",
  ORIGINAL_SUBMISSION_DATE: "Data de envio original",
  ORIGINALLY_SUBMITTED: "Submetido originalmente",
  OTHER: "Outro",
  OTHER_AMOUNT_OF_USE: "Outra Quantidade de Uso",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Outra Quantidade de Uso Obrigat\xF3ria",
  OTHER_CREDIT: "Outros Cr\xE9ditos",
  OTHER_CREDIT_1: "Outros Cr\xE9ditos 1",
  OTHER_CREDIT_2: "Outros Cr\xE9ditos 2",
  OTHER_CREDIT_3: "Outros Cr\xE9ditos 3",
  OTHER_CREDIT_ADJUSTMENT: "Ajuste de Outros Cr\xE9ditos",
  OTHER_CREDIT_ITEM_DETAILS: "Outros Cr\xE9ditos - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Total de outros cr\xE9ditos",
  OTHER_CREDITS: "Outros Cr\xE9ditos",
  OTHER_CREDITS_WITH_COUNT: "Outros cr\xE9ditos ({count})",
  OTHER_INSTRUCTIONS: "Outras instru\xE7\xF5es",
  OUTPUT_PIN: "Resultado do n\xFAmero de s\xE9rie",
  OVERDUE: "Atrasado",
  OVERRIDE_ACCOUNT: "Cancelar Conta",
  OVERRIDE_EFFECTIVE_DATE: "Data de Vig\xEAncia da Substitui\xE7\xE3o",
  OVERRIDE_SUGGESTED_ACCOUNT: "Cancelar Conta Sugerida",
  OWNERSHIP_STATUS: "Status de Propriedade",
  OWNERSHIP_STATUS_IS_REQUIRED: "\xC9 necess\xE1rio o status da propriedade",
  PART: "Pe\xE7a",
  PART_1: "Pe\xE7a 1",
  PART_2: "Pe\xE7a 2",
  PART_3: "Pe\xE7a 3",
  PART_4: "Pe\xE7a 4",
  PART_5: "Pe\xE7a 5",
  PART_6: "Pe\xE7a 6",
  PART_7: "Pe\xE7a 7",
  PART_8: "Pe\xE7a 8",
  PART_9: "Pe\xE7a 9",
  PART_10: "Pe\xE7a 10",
  PART_AMONT_OF_USE: "Volume de utiliza\xE7\xE3o da pe\xE7a",
  PART_FAMILY: "Fam\xEDlia da Pe\xE7a",
  PART_ITEM_DETAILS: "Pe\xE7as - {quantity} {description} N\xFAmero da Pe\xE7a {partNumber}",
  PART_NUMBER: "N\xFAmero da Pe\xE7a",
  PART_REQUEST: "Solicita\xE7\xE3o de Pe\xE7a",
  PART_REQUEST_NUMBER: "Solicita\xE7\xE3o de Pe\xE7a {rgaNumber}",
  PART_REQUEST_STATUS: "Status de Solicita\xE7\xE3o de Pe\xE7a",
  PART_REQUESTS: "Solicita\xE7\xF5es de Pe\xE7as",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Introduza o n\xFAmero da reclama\xE7\xE3o, no m\xEDnimo 4 caracteres",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "A Pesquisa da Solicita\xE7\xE3o deve ter, pelo menos, 4 caracteres",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "A pesquisa do n\xFAmero de caso DTAC deve ser o n\xFAmero de caso DTAC completo, pelo menos 4 caracteres",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Introduza o n\xFAmero de caso DTAC completo",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "A Pesquisa do n\xFAmero da pe\xE7a deve ter, pelo menos, 4 caracteres",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Introduza o n\xFAmero da pe\xE7a, no m\xEDnimo 4 caracteres",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "A pesquisa do n\xFAmero da pe\xE7a deve ter, pelo menos, 4 caracteres",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Introduza o n\xFAmero de pedido da pe\xE7a, no m\xEDnimo 4 caracteres",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "A pesquisa do PIN deve ter, pelo menos, 4 caracteres",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Introduza o PIN, no m\xEDnimo 4 caracteres",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "A pesquisa da ordem de servi\xE7o deve ser a ordem de servi\xE7o completa, pelo menos 2 caracteres",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Introduza a ordem de servi\xE7o completa",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Pedido da pe\xE7a atualizado com \xEAxito",
  PART_RETURN: "Retorno de Pe\xE7a",
  PART_RETURNS: "Retornos de Pe\xE7as",
  PART_SERIAL_NUMBER: "N\xFAmero de S\xE9rie da Pe\xE7a",
  PART_SERIAL_NUMBER_IS_REQUIRED: "\xC9 necess\xE1rio o n\xFAmero de s\xE9rie da pe\xE7a",
  PART_TOTAL: "Total de pe\xE7as",
  PART_TYPE: "Tipo de pe\xE7a",
  PART_USE: "Utiliza\xE7\xE3o da pe\xE7a",
  PART_VALUE: "Valor da Pe\xE7a",
  PARTIAL_DEBIT: "D\xE9bito Parcial",
  PARTICIPANT: "Participante",
  PARTS: "PE\xC7AS",
  PARTS_ADDITIVE: "Aditivo Pe\xE7as",
  PARTS_ADJUSTMENT: "Ajuste de Pe\xE7as",
  PARTS_COVERAGE_SEARCH: "Pesquisa de Cobertura de Pe\xE7as",
  PARTS_TEMPLATE: "Modelo de Pe\xE7as",
  PARTS_USE: "Uso da Pe\xE7a",
  PARTS_USE_IS_REQUIRED: "\xC9 necess\xE1ria a utiliza\xE7\xE3o de pe\xE7as",
  PARTS_WITH_COUNT: "Pe\xE7as ({count})",
  PARTS_WITH_PARENTHESES: "Pe\xE7a(s)",
  PAST_DUE: "Vencido",
  PAYER_ACCOUNT: "Conta do Pagador",
  PERCENT_COMPLETE: "Percentagem Completa",
  PERCENTAGE: "Porcentagem",
  PERCENTAGE_DEBIT: "D\xE9bito Percentual",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "Porcentagem para D\xE9bito",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "Para m\xE1quinas permanentemente fora de servi\xE7o, inclua uma imagem da m\xE1quina para verifica\xE7\xE3o de que ela n\xE3o pode ser reconstru\xEDda, reparada ou usada futuramente. M\xE1quinas permanentemente fora de servi\xE7o n\xE3o se enquadram em PIPs de nenhum tipo.",
  PERSON_RESPONSIBLE: "Pessoa Respons\xE1vel",
  PHONE: "Telefone",
  PHONE_REQUIRED: "Telefone Necess\xE1rio",
  PICTURE: "Imagem",
  PICTURE_REQUEST: "Solicita\xE7\xE3o de Imagens",
  PICTURE_REQUEST_STATUS: "Status da Solicita\xE7\xE3o de Imagens",
  PICTURE_REQUEST_STATUS_ERROR: "Os anexos est\xE3o prontos para serem enviados com essa solicita\xE7\xE3o.",
  PIN: "N\xBA de S\xE9rie",
  PIN_CREATED_SUCCESSFULLY: "PIN criado com sucesso",
  PIN_CROSS_REFERENCE: "Refer\xEAncia Cruzada  de n\xFAmero de s\xE9rie",
  PIN_INVALID: "PIN Inv\xE1lido",
  PIN_IS_REQUIRED: "O N\xFAmero de Identifica\xE7\xE3o do Produto (PIN) \xE9 obrigat\xF3rio.",
  PIN_REQUIRED: "PIN Obrigat\xF3rio",
  PIN_SEARCH: "Pesquisa por Pino",
  PIN_SEARCH_INFORMATION: "Informa\xE7\xF5es de Pesquisa de Pino",
  PIN_TRANSFER_INFORMATION: "Informa\xE7\xF5es de Transfer\xEAncia de Pino",
  PINS: "PINs",
  PINS_NOT_REGISTERED: "M\xE1quina sem Registro",
  PIP: "Programa de Melhoria de Produto (PMP)",
  PIP_CODE: "C\xF3digo PMP",
  PIP_CODE_CREATED_SUCCESSFULLY: "Pedido de c\xF3digo PIP criado com \xEAxito",
  PIP_CODE_REQUEST: "Solicita\xE7\xE3o de c\xF3digo PMP",
  PIP_CODE_REQUEST_APPROVED: "Pedido de c\xF3digo PMP aprovado",
  PIP_CODE_REQUEST_REJECTED: "Pedido de c\xF3digo PMP rejeitado",
  PIP_CODE_REQUESTS_WITH_COUNT: "Pedidos de c\xF3digo PMP ({count})",
  PIP_COMPLETION_STATUS: "Status PMP Completo",
  PIP_DETAILS: "Detalhes do PMP",
  PIP_HISTORY: "Hist\xF3rico de PMPIP",
  PIP_ID: "PMP N\xBA",
  PIP_NUMBER: "N\xBA do PMP",
  PIP_PROGRAM: "Programa PMP",
  PIP_PROGRAM_IS_REQUIRED: "\xC9 necess\xE1rio o programa PMP",
  PIP_PROGRAMS: "Programas PMP",
  PIP_SEARCH: "Busca do PMP",
  PIP_STATUS: "Status de PMP",
  PIP_TYPE: "Tipo de PMP",
  PIP_TYPES: "Tipos de PMP",
  PIPS: "PMPs",
  PIPS_UNPAID_LABOR_ADDITIVE: "Aditivos  de M\xE3o de Obra n\xE3o pago nos PMP",
  PLAN_DESCRIPTION: "Descri\xE7\xE3o do Plano",
  PLAN_END_DATE: "Planejar Data Final",
  PLAN_ENDS: "Planejar Data final",
  PLAN_NAME: "Nome do Plano",
  PLAN_NAME_IS_REQUIRED: "\xC9 necess\xE1rio o nome do plano",
  PLAN_NAMES: "Nomes do Plano",
  PLAN_START_DATE: "Data de In\xEDcio do Plano",
  PLAN_STARTS: "Planejar Data inicial",
  PLANNED_BY: "Planejado por",
  PLANT: "Planta",
  PLATE_REQUEST_INFORMATION: "Informa\xE7\xF5es de Solicita\xE7\xE3o de Placa",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Selecione uma conta principal",
  PLEASE_SELECT_CLAIM_TYPE: "Por Favor, Selecione o Tipo de Solicita\xE7\xE3o",
  POLISH: "Polon\xEAs",
  PORTUGUESE: "Portugu\xEAs",
  POSTAGE_DELIVERY_DATE: "Data de entrega da postagem",
  POSTAL_CODE: "C\xF3digo Postal",
  POSTAL_CODE_REQUIRED: "C\xF3digo Postal Necess\xE1rio",
  POSTAL_TRACKING_NUMBER: "N\xFAmero de rastreamento postal",
  POTENTIAL_RESPONSIBLE_DEALER: "Concession\xE1rio potencialmente respons\xE1vel",
  PRE_DELIVERY_INSPECTION: "Inspe\xE7\xE3o Pr\xE9-Entrega",
  PREFERRED_THEME: "Tema Preferido",
  PREPARE_AUDIT: "Preparar Auditoria",
  PREPARED: "Preparado",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Preparar a Auditoria para {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Quantidade de Uso anterior",
  PREVIOUS_INVOICE_NUMBER: "N\xFAmero da fatura anterior",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "\xC9 necess\xE1rio o n\xFAmero da fatura anterior",
  PREVIOUS_MONTH: "M\xEAs Anterior",
  PRICE: "Pre\xE7o",
  PRICING_SUMMARY: "Resumo dos pre\xE7os",
  PRIMARY_ACTION: "A\xE7\xE3o Prim\xE1ria",
  PRIMARY_LANGUAGE: "Idioma Prim\xE1rio",
  PRINT: "Imprimir",
  PRINT_CLAIM: "Imprimir reclama\xE7\xE3o",
  PRINT_REGISTRATION_FORM: "Imprimir Formul\xE1ario de Registro",
  PRINT_REGISTRATION_FORM_MESSAGE: "Produto Registrado para o Primeiro Dono. Gostaria de Imprimir o Formul\xE1rio de Registro Agora?",
  PRINT_TO_PDF: "Imprimir PDF",
  PRIORITY: "Prioridade",
  PRNT_CLM: "Exibir solicita\xE7\xE3o",
  PROCESS_DATE: "Data de processamento",
  PROCESSED: "Processado",
  PROCESSED_PART_REQUESTS: "Solicita\xE7\xF5es de pe\xE7a processada",
  PROCESSING_STATUS: "Situa\xE7\xE3o de processamento",
  PROCESSING_STATUS_DESCRIPTION: "Descri\xE7\xE3o da Situa\xE7\xE3o do processamento",
  PRODUCT_DETAILS: "Detalhes do Produto",
  PRODUCT_HIERARCHY: "Hierarquia de Produtos",
  PRODUCT_INFORMATION: "Informa\xE7\xE3o do Produto",
  PRODUCT_REGISTERED: "Produto Registrado",
  PRODUCT_REGISTRATION: "Registros do Produto",
  PRODUCT_REGISTRATION_PENDED: "Registro do produto est\xE1 pendente",
  PRODUCT_TRACKING: "Rastreamento do Produto",
  PRODUCTS: "Produtos",
  PRODUCTS_BY_CUSTOMER: "Produtos por Cliente",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "PINs hist\xF3ricos podem estar faltando nos resultados da pesquisa devido a um problema tempor\xE1rio de conectividade do sistema",
  PRODUCTS_WITH_COUNT: "Produtos ({count})",
  PROGRAM: "Programa",
  PROGRAM_DESCRIPTION: "Descri\xE7\xE3o do Programa",
  PROGRAM_IS_REQUIRED: "O nome do programa \xE9 obrigat\xF3rio.",
  PROGRAM_NAME: "Nome do Programa",
  PROGRAM_NAME_IS_REQUIRED: "O nome do programa \xE9 obrigat\xF3rio.",
  PROGRAM_NUMBER: "N\xFAmero do Programa",
  PRT: "PRT",
  PRTS: "PRTs",
  PURCHASE_INFO: "Informa\xE7\xF5es de Compra",
  PURCHASE_ORDER: "Ordem de compra",
  PURCHASE_ORDER_IS_REQUIRED: "\xC9 necess\xE1ria a ordem de compra",
  PURCHASER_TYPE: "Tipo de Compra",
  PURCHASER_TYPE_REQUIRED: "Tipo de Comprador Obrigat\xF3rio",
  PUSH_XML: "Reenviar XML",
  QTY: "Quantidade",
  QUALIFY_FOR_EMISSIONS: "Qualificar para Emiss\xF5es",
  QUANTITY: "Quantidade",
  QUANTITY_1: "Quantidade 1",
  QUANTITY_2: "Quantidade 2",
  QUANTITY_3: "Quantidade 3",
  QUANTITY_4: "Quantidade 4",
  QUANTITY_5: "Quantidade 5",
  QUANTITY_6: "Quantidade 6",
  QUANTITY_7: "Quantidade 7",
  QUANTITY_8: "Quantidade 8",
  QUANTITY_9: "Quantidade 9",
  QUANTITY_10: "Quantidade 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "A consulta deve conter no m\xEDnimo 3 caracteres",
  QUEST_DESC: "Descri\xE7\xE3o do Question\xE1rio",
  QUESTIONABLE_PART: "Pe\xE7a Question\xE1vel",
  QUEUED: "Em fila",
  REASON_FOR_CHANGE: "Raz\xE3o para trocar",
  REASON_FOR_DEBIT: "Motivo para o D\xE9bito",
  REASON_FOR_MISSING_PLATE: "Motivo para a Placa Ausente",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Motivo para a Falta da Placa Necess\xE1ria",
  REASON_FOR_OVERRIDE: "Motivo para a Substitui\xE7\xE3o",
  REASON_FOR_REFUSAL: "Motivo da Recusa",
  REASON_FOR_RETURN: "Motivo da devolu\xE7\xE3o",
  REASON_FOR_RETURN_IS_REQUIRED: "\xC9 necess\xE1rio o motivo da devolu\xE7\xE3o",
  REASON_FOR_TRANSFER: "Motivo para Transfer\xEAncia",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "O Motivo para a Transfer\xEAncia deve Conter caracteres alfanum\xE9ricos",
  RECIPIENT_DEALER_OR_TCSM: "Destinat\xE1rio (Concession\xE1rio ou TCSM)",
  RECIPIENT_MAILING: "Destinat\xE1rio para Correspond\xEAncia",
  RECONCILE: "Reconciliar",
  RECONCILE_CLAIM: "Reconciliar a Solicita\xE7\xE3o",
  RECONCILED: "RECONCILIADO",
  RECORD_AUDIT: "Registo da auditoria",
  RECORD_AUDIT_FOR: "Registo da auditoria para {dealer}",
  RECORDS_FOUND: "{countToDisplay} {count, plural, one {registro encontrado} other {registros encontrados}}",
  RECOVERABLE_TAXES: "Impostos Recuper\xE1veis",
  RECOVERED: "Recuperado",
  RECOVERED_WITH_MISSED_ADDITIVES: "Recuperado com Aditivos em Falta",
  RECOVERED_WITHOUT_ADDITIVES: "Recuperado sem Aditivos",
  RECOVERY: "Recupera\xE7\xE3o",
  RED_MUST_BE_LESS_THAN_YELLOW: "O valor do indicador vermelho deve ser inferior ao valor do indicador amarelo",
  REFERENCE_1: "Refer\xEAncia 1",
  REFERENCE_2: "Refer\xEAncia 2",
  REFERENCE_INFORMATION: "Informa\xE7\xF5es de Refer\xEAncia",
  REFERENCE_NUMBER1: "N\xBA de Refer\xEAncia 1",
  REFERENCE_NUMBER2: "N\xBA de Refer\xEAncia2",
  REGION: "Regi\xE3o",
  REGISTER: "Registrar",
  REGISTER_A_PRODUCT_BY_PIN: "Registrar um produto pelo PIN",
  REGISTER_A_PRODUCT_TO_ADD: "Registrar um Produto para Adicion\xE1-lo ao sistema de Garantia",
  REGISTER_ANOTHER_PRODUCT: "Registre outro Produto",
  REGISTER_PRODUCT: "Registro do Produto",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Registrar um Produto e Outro",
  REGISTERED: "Registrado",
  REGISTRATION: "Registro",
  REGISTRATION_DATE: "Data de Registro",
  REGISTRATION_DATES: "Datas de Registros",
  REGISTRATION_FORM: "Formul\xE1rio de Registro",
  REGISTRATION_HISTORY: "Hist\xF3rico de Registros",
  REGISTRATION_NOT_ALLOWED: "Registro n\xE3o permitido para este produto",
  REGISTRATION_REVIEW: "An\xE1lise de Registro",
  REGISTRATION_REVIEW_TAB: "An\xE1lise de Registro ({count})",
  REGISTRATION_STATUS: "Status do Registro",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "O Status do Registro n\xE3o pode ser Novo",
  REGISTRATION_STATUS_REQUIRED: "\xC9 necess\xE1rio ter o Status do Registro",
  REGISTRATION_SUCCESS: "Registro Bem-sucedido",
  REGISTRATION_TYPE: "Tipo de Registro",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Tipo de Registro n\xE3o pode ser Novo",
  REGISTRATION_TYPE_REQUIRED: "Tipo de Registro Obrigat\xF3rio",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Registro Atualizado com sucesso",
  REGISTRATIONS_REVIEW: "An\xE1lise de Registros",
  REIMBURSED: "Reembolsado",
  REIMBURSED_AMOUNT: "Montante do reembolso",
  REIMBURSED_PERCENTAGE: "Percentagem do reembolso",
  REIMBURSED_PERCENTAGE_INDICATOR: "Indicador de percentagem do reembolso",
  REIMBURSEMENT_DETAILS: "Detalhes do reembolso",
  REIMBURSEMENT_PERCENTAGE: "Percentagem do reembolso",
  REIMBURSEMENT_SUMMARY: "Resumo do Reembolso",
  REJECT: "Rejeitar",
  REJECT_LABOR_RATE: "Rejeitar o Valor da m\xE3o de obra",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Rejeitar Solicita\xE7\xE3o de Concess\xE3o Especial",
  REJECTED: "Reprovado",
  REJECTED_APPEAL: "Apelo rejeitado",
  RELATIONSHIP: "Rela\xE7\xE3o",
  RELATIONSHIP_IS_REQUIRED: "\xC9 necess\xE1ria a rela\xE7\xE3o",
  REMOVE_FILTER: "Remover filtro",
  REMOVE_FROM_AUDIT: "Remover da auditoria",
  REMOVE_LAYOUT: "Remove Layout",
  RENTAL_PINS: "PINs de aluguel",
  REPAIR_DATE: "Data do Reparo",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "A data do reparo n\xE3o pode ser anterior \xE0 data da falha",
  REPAIR_NUMBER: "N\xFAmero de Reparo",
  REPAIR_NUMBER_IS_REQUIRED: "\xC9 necess\xE1rio o n\xFAmero da repara\xE7\xE3o",
  REPAIR_REPLACE_INDICATOR: "Indicador de reparo/substitui\xE7\xE3o",
  REPAIRED: "Reparado",
  REPAIRED_DATE: "Data da repara\xE7\xE3o",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "A data do Reparo n\xE3o pode ser anterior \xE0 data da Falha",
  REPAIRED_DATE_IS_REQUIRED: "\xC9 necess\xE1ria a data da repara\xE7\xE3o",
  REPORT_DATE: "Data Relatada",
  REPORT_NUMBER: "N\xFAmero do Documento",
  REPORTS: "Relat\xF3rios",
  REQ_ADDL: "Ajuste de Cr\xE9dito",
  REQUEST_DATE: "Data de Requisi\xE7\xE3o",
  REQUEST_DETAILS: "Detalhes",
  REQUEST_DUPLICATE_PIN_PLATE: "Solicitar Duplica\xE7\xE3o da Placa do PIN",
  REQUEST_FORM: "Formul\xE1rio de Solicita\xE7\xE3o",
  REQUEST_PIP_CODE: "C\xF3digo PIP de Solicita\xE7\xE3o",
  REQUEST_STATUS: "Status da Solicita\xE7\xE3o",
  REQUEST_SUBMITTED: "Pedido enviado",
  REQUEST_TYPE: "Tipo de solicita\xE7\xE3o",
  REQUEST_UPDATED_SUCCESSFULLY: "Solicita\xE7\xE3o atualizado",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Solicitar D\xE9bito de Solicita\xE7\xE3o de Garantia",
  REQUESTED: "Solicitado",
  REQUESTED_BY: "Solicitado por",
  REQUESTED_DATE: "Data da solicita\xE7\xE3o",
  REQUESTED_DATES: "Datas Solicitadas",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Quantia Desejada de Diagn\xF3stico",
  REQUESTED_DIAGNOSTIC_HOURS: "Horas de Diagn\xF3stico Desejada",
  REQUESTED_LABOR_AMOUNT: "Volume de m\xE3o de obra pedido",
  REQUESTED_LABOR_HOURS: "Horas de Trabalho Solicitadas",
  REQUESTED_OTHER_CREDITS: "Outros cr\xE9ditos pedidos",
  REQUESTED_PARTS: "Pe\xE7as Solicitadas",
  REQUESTED_REPAIR_AMOUNT: "Quantia Desejada de Reparo",
  REQUESTED_REPAIR_HOURS: "Horas de Reparo Desejada",
  REQUESTED_TRAVEL_TOTAL: "Tempo total de deslocamento solicitado",
  REQUESTER_TCSM: "Solicitante(TCSM)",
  REQUESTER_TCSM_REQUIRED: "Solicitante (TCSM) Necess\xE1rio",
  REQUIRED: "Obrigat\xF3rio",
  REQUIRED_CRITERIA: "Crit\xE9rios Obrigat\xF3rios",
  REQUIRED_ITEMS: "Itens Obrigat\xF3rios",
  RESEND_XML: "Reenviar XML",
  RESET: "Redefinir",
  RESPONDENT_INFORMATION: "Informa\xE7\xF5es do inquirido",
  RESPONSIBILITY_OF: "Responsabilidade de",
  RESPONSIBLE_ACCOUNT: "Conta Respons\xE1vel",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "\xC9 necess\xE1rio ter a conta respons\xE1vel",
  RESPONSIBLE_DEALER: "Concession\xE1rio Respons\xE1vel",
  RET: "Devolu\xE7\xE3o",
  RETAIL_INSTALL: "Revenda/instala\xE7\xE3o",
  RETAIL_INSTALL_DATE: "Venda/Data de Instala\xE7\xE3o",
  RETAIL_INSTALL_IS_REQUIRED: "\xC9 necess\xE1ria a revenda/instala\xE7\xE3o",
  RETAILER_NAME: "Nome do Varejo",
  RETAILER_NAME_IS_REQUIRED: "\xC9 necess\xE1rio o nome do revendedor",
  RETRY: "nova tentativa",
  RETURN: "Devolu\xE7\xE3o",
  RETURN_LABOR_RATE: "Taxa de m\xE3o de obra de retorno",
  RETURN_REQUEST: "Pedido de Devolu\xE7\xE3o",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Devolver Solicita\xE7\xE3o de Concess\xE3o Especial",
  RETURN_STATUS: "Status de Retorno",
  RETURNED: "Retornado",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "A data de devolu\xE7\xE3o n\xE3o pode ser anterior \xE0 data de entrega",
  RETURNED_DATE_IS_REQUIRED: "\xC9 necess\xE1ria a data de devolu\xE7\xE3o",
  REVIEW_DEALER_RECOMMENDATIONS: "Tem certeza de que deseja marcar o pino para Revis\xE3o?",
  REVISE: "Revisar",
  REVISED: "Revisado",
  ROLLING_12_CREDIT_AMOUNT: "Prorroga\xE7\xE3o do Montante de 12 cr\xE9ditos",
  ROLLING_12_MONTHS: "Prorroga\xE7\xE3o de 12 meses consecutivos",
  RUN_REPORT: "Executar Relat\xF3rio",
  RUSSIAN: "Russo",
  SAP_DOWN_WARNING: "A funcionalidade do Sistema de Garantia est\xE1 prejudicada. Estamos trabalhando para corrigir isso o mais r\xE1pido poss\xEDvel. Atualize o navegador para verificar a disponibilidade do sistema.",
  SAVE: "Salvar",
  SAVE_AS_DRAFT: "Salvar como Rascunho",
  SAVE_AS_NEW_LAYOUT: "Salvar como novo layout",
  SAVE_AUDIT: "Salvar auditoria",
  SAVE_CHANGES: "Salvar altera\xE7\xF5es",
  SAVE_TO_VALIDATE: "Salvar para validar",
  SAVE_VALD: "Salvar e Validar",
  SAVE_VALIDATE: "Salvar e Validar",
  SEARCH: "Pesquisar",
  SEARCH_BOX_PLACEHOLDER: "Inserir PIN, N\xBA de S\xE9rie, n\xFAmero de Solicita\xE7\xE3o, Caso do DTAC ou Nome do Cliente",
  SEARCH_BY_CLAIM_TYPE: "Introduza o Tipo de Solicita\xE7\xE3o Completo",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "A Pesquisa da Solicita\xE7\xE3o deve ser pelo Tipo de Solicita\xE7\xE3o com n\xFAmero completo, entre 4 e 9 Caracteres",
  SEARCH_BY_FAILURE_PART_NUMBER: "Introduza o N\xFAmero da Pe\xE7a  Falha Completo",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "A pesquisa da Solicita\xE7\xE3o deve ser pelo Tipo de Solicita\xE7\xE3o com n\xFAmero completo, no m\xEDnimo 4 caracteres",
  SEARCH_BY_WORK_ORDER: "Introduza a ordem de servi\xE7o, no m\xEDnimo 2 caracteres",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "A pesquisa da ordem de servi\xE7o deve ter no m\xEDnimo 2 caracteres",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Inserir o n\xFAmero completo da Solicita\xE7\xE3o",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "A pesquisa de solicita\xE7\xE3o deve ser feita pelo n\xFAmero completo da solicita\xE7\xE3o, de 4 a 9 caracteres",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Insira o n\xFAmero de s\xE9rie completo do Componente",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "A pesquisa de componentes deve ser efetuada atrav\xE9s do n\xFAmero de s\xE9rie completo, pelo menos 1 caracter",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Inserir PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Insira o n\xFAmero completo do Modelo",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "A pesquisa pelo modelo deve ser feita pelo n\xFAmero completo do modelo, de 3 a 12 caracteres",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Introduza o PIN, no m\xEDnimo 6 caracteres",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "A pesquisa do PIN deve ter entre 6 e 17 caracteres",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Insira o n\xFAmero PIP, no m\xEDnimo 4 caracteres",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "A pesquisa pelo PIP deve ter de 4 a 12 caracteres",
  SEARCH_RESULTS_TAB: "Resultados da Busca ({count})",
  SECOND_SHIP_TO_LOCATION: "Segundo envio para o local",
  SELECT: "Selecionar",
  SELECT_A_RANGE: "Selecionar um intervalo",
  SELECT_ALL: "Selecionar Tudo",
  SELECT_AUTO_SUBMIT: "Selecionar Envio Autom\xE1tico",
  SELECT_BRANCH: "Selecionar Filial",
  SELECT_CLAIM_TYPE: "Selecione o tipo de Solicita\xE7\xE3o",
  SELECT_CLAIMS: "Selecione Solicita\xE7\xF5es",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "Selecione Solicita\xE7\xF5es para um per\xEDodo determinado",
  SELECT_COLUMNS: "Selecione colunas",
  SELECT_COUNTRY: "Selecionar Pa\xEDs",
  SELECT_CSV_SEPARATOR: "Selecionar CSV Separator",
  SELECT_DATE_FORMAT: "Selecionar Formato da Data",
  SELECT_DEALERS_AND_STATUS: "Selecionar Concession\xE1rios e Status",
  SELECT_DECIMAL_FORMAT: "Selecionar Formato Decimal",
  SELECT_DISPLAY_FORMAT: "Selecionar Formato de Exibi\xE7\xE3o",
  SELECT_FACTORY: "Selecionar F\xE1brica",
  SELECT_LANGUAGE: "Selecionar Idioma",
  SELECT_LAYOUT: "Selecionar Layout",
  SELECT_NEW_CLAIMS: "Selecione Novas Solicita\xE7\xF5es ",
  SELECT_PIP_CODE: "Selecionar c\xF3digo PIP",
  SELECT_PLAN_NAMES: "Selecionar Nomes do Plano",
  SELECT_SERVICE_INTERVAL_TYPES: "Selecionar Tipos de Intervalo de Servi\xE7o",
  SELECT_SORT_BY: "Selecionar Classificar por",
  SELECT_SORT_DIRECTION: "Selecionar Ordenar Dire\xE7\xE3o",
  SELECT_STATE: "Selecionar Estado",
  SELECT_STATUS: "Selecionar Status",
  SELECT_TERRITORY: "Selecionar territ\xF3rio",
  SELECT_THEME: "Selecionar Tema",
  SELECT_TIME_ZONE: "Selecionar Fuso-Hor\xE1rio",
  SELECT_VALUES_TO_APPROVE: "Selecionar valores a aprovar",
  SELECTED_COLUMNS: "Selecionada Colunas",
  SELECTED_FOR_AUDIT: "Selecionado para Auditoria",
  SELECTED_FOR_AUDIT_VSR: "Consulte a Solu\xE7\xE3o DTAC 221475 para obter a documenta\xE7\xE3o de auditoria e os anexos necess\xE1rios para esta reclama\xE7\xE3o.",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Selecionar Diversas Contas & Tipos de Garantias que Afetam a performance.",
  SEND: "Enviar",
  SERIAL_NUMBER: "N\xFAmero de S\xE9rie",
  SERIAL_NUMBER_INVOICE_NUMBER: "N\xFAmero de S\xE9rie / N\xFAmero da Fatura",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "O Servidor demorou demais a responder e o pedido foi cancelado. Por Favor, tente uma Solicita\xE7\xE3o mais mais espec\xEDfica ou tente novamente mais tarde.",
  SERVICE_DATE_IS_REQUIRED: "\xC9 necess\xE1ria a data do servi\xE7o",
  SERVICE_INTERVAL: "Intervalo de Servi\xE7o",
  SERVICE_INTERVAL_BEGIN_DATE: "Data de In\xEDcio do Intervalo de Servi\xE7os",
  SERVICE_INTERVAL_END_DATE: "Data Final do Intervalo de Servi\xE7os",
  SERVICE_INTERVAL_IS_REQUIRED: "\xC9 necess\xE1rio o intervalo de manuten\xE7\xE3o",
  SERVICE_INTERVAL_NUMBER: "N\xFAmero do Intervalo de Servi\xE7os",
  SERVICE_INTERVAL_STATUS: "Status do Intervalo de Servi\xE7o",
  SERVICE_INTERVAL_TYPE: "Tipo de Intervalo de Servi\xE7o",
  SERVICE_INTERVAL_TYPES: "Tipos de Intervalo de Servi\xE7o",
  SERVICE_PART: "Parte de servi\xE7o",
  SERVICE_UNAVAILABLE: "Servi\xE7o Indispon\xEDvel",
  SERVICED: "Submetido \xE0 Manuten\xE7\xE3o",
  SERVICED_DATE_IS_REQUIRED: "\xC9 necess\xE1ria a data do servi\xE7o",
  SET_AS_DEFAULT: "Definir como padr\xE3o",
  SETTINGS: "Minhas Configura\xE7\xF5es",
  SETTLED: "Quitado",
  SETTLEMENT_NO_REGISTRATION: "Acordo e Aus\xEAncia de Registro",
  SETUP: "Configura\xE7\xE3o",
  SETUP_DATE_IS_REQUIRED: "\xC9 necess\xE1ria a data de configura\xE7\xE3o",
  SETUP_IS_REQUIRED: "\xC9 necess\xE1ria a configura\xE7\xE3o",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Enviado para",
  SHIPPED: "Enviado",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Informa\xE7\xF5es de envio/instru\xE7\xF5es especiais",
  SHIPPING_INSTRUCTIONS: "Instru\xE7\xF5es de Envio",
  SHORT_TEXT: "Pequeno texto",
  SHORT_TEXT_IS_REQUIRED: "Texto curto \xE9 obrigat\xF3rio",
  SHOW_ALL: "Mostrar tudo ({count})",
  SHOW_EXCLUDED: "Mostrar Exclu\xEDdo",
  SHOW_MORE: "Mostrar mais",
  SHOW_MORE_GROUPS: "Mostrar {countToDisplay} mais {count, plural, one {grupo} other {grupos}}",
  SHOW_RED_IF_LESS_THAN: "Mostrar Vermelho se Inferior a",
  SHOW_REIMBURSED_AMOUNT: "Mostrar montante do reembolso",
  SHOW_REIMBURSED_PERCENTAGE: "Mostrar percentagem do reembolso",
  SHOW_YELLOW_IF_LESS_THAN: "Mostrar Amarelo se for Inferior a",
  SIGN_IN_REQUIRED: "Login obrigat\xF3rio",
  SIGN_OUT: "Sair",
  SKIP_AUDIT: "Ignorar Auditoria",
  SKIP_AUDIT_SUCCESS: "A Auditoria foi ignorada e a data de vencimento est\xE1 no futuro.",
  SOME_PARTS_RETURNED: "Algumas Pe\xE7as Devolvidas",
  SORT_BY: "Classificar por",
  SPANISH: "Espanhol",
  SPECIAL_ALLOWANCE: "Cortesia/Solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_CALCULATION: "C\xE1lculo de solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_CLAIM: "Solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Status da Solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Status da Solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Status da Solicita\xE7\xE3o de Concess\xE3o Especial - atualizado",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Solicita\xE7\xE3o de Concess\xE3o Especial - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Solicita\xE7\xF5es de Concess\xF5es Especiais ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Contribui\xE7\xF5es da Solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Descri\xE7\xE3o da solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_ALLOWANCE_TYPE: "Tipo de Concess\xE3o Espcial",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "\xC9 necess\xE1rio o Tipo de Solicita\xE7\xE3o de Concess\xE3o Especial",
  SPECIAL_INSTRUCTIONS: "Instru\xE7\xF5es Especiais",
  SPG: "SPG",
  SPGS: "SPGs",
  STANDARD_VIEW: "Vis\xE3o geral",
  START_AMOUNT_OF_USE: "Iniciar quantidade de Utiliza\xE7\xE3o",
  STARTS: "Come\xE7ar",
  STARTS_WITH: "Come\xE7ar com",
  STATE: "Estado",
  STATE_PROVINCE: "Estado/Prov\xEDncia",
  STATE_PROVINCE_REQUIRED: "Estado/Prov\xEDncia Necess\xE1rio",
  STATUS: "Status",
  STATUS_CHANGE_REQUEST: "Pedido de Mudan\xE7a de Status",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Pedido de Altera\xE7\xE3o de Status Criado com \xCAxito",
  STATUS_FOR: "Status para {pin}",
  STATUS_INDICATOR: "Indicador de Status",
  STATUS_REASON: "Raz\xE3o de Status",
  STOLEN_DATE: "Data do Roubo",
  STORE: "Loja",
  STORE_IS_REQUIRED: "\xC9 necess\xE1ria a loja",
  STORE_NUMBER_IS_REQUIRED: "\xC9 necess\xE1rio o n\xFAmero da loja",
  STREET_1: "Endere\xE7o 1",
  STREET_2: "Endere\xE7o 2",
  SUB: "Enviar",
  SUB_CLAIM_TYPE: "Tipo de Garantia Substituta",
  SUB_TYPE: "Subtipo",
  SUBMISSION_DATE: "Data de Transmiss\xE3o",
  SUBMIT: "Enviar/Submeter",
  SUBMIT_AUDIT: "Enviar auditoria",
  SUBMIT_AUDIT_FOR: "Enviar Auditoria para {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Enviar Solicita\xE7\xE3o de D\xE9bito Completo para {claimNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Enviar reclama\xE7\xE3o de d\xE9bito parcial para {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Enviar Solicita\xE7\xE3o de D\xE9bito de Porcentagem para {claimNumber}",
  SUBMIT_REQUEST: "Enviar pedido",
  SUBMITTED: "Enviado",
  SUBMITTED_AVAILABLE_TO_EDIT: "Enviado (Edit\xE1vel)",
  SUCCESS: "Sucesso",
  SUCCESS_MESSAGE_TITLE: "Uma opera\xE7\xE3o foi efetuada com \xEAxito:",
  SUCCESS_MESSAGES_TITLE: "V\xE1rias opera\xE7\xF5es foram efetuadas com \xEAxito:",
  SUPPLIER_WARRANTY: "Garantia do Fornecedor",
  SURVEY_QUESTIONS: "Perguntas da Pesquisa",
  SUSPENDED: "Suspendido",
  SWEDISH: "Sueco",
  SYSTEM_SELECTED_CLAIMS: "Reclama\xE7\xF5es selecionadas no sistema",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Solicita\xE7\xF5es Selecionadas no Sistema ({count})",
  TABM: "TABM",
  TAX: "Impostos",
  TCSM: "TCSM",
  TECH_ID: "ID do T\xE9cnico",
  TERMINATED: "Terminado",
  TERMINATES: "Terminar",
  TERRITORY: "Territ\xF3rio",
  TEST: "Teste",
  TEST_RESULTS_CODE: "C\xF3digo do Resultado do Teste",
  THEME: "Tema",
  TIME_LIMIT: "Prazo",
  TIME_ZONE: "Fuso Hor\xE1rio",
  TITLE: "T\xEDtulo",
  TITLE_IS_REQUIRED: "T\xEDtulo \xE9 obrigat\xF3rio",
  TO: "Para",
  TODAY: "Hoje",
  TOO_MANY_RESULTS: "Sua solicita\xE7\xE3o retornou muitos resultados. Por favor, restrinja seus termos de pesquisa e tente novamente.",
  TOTAL: "Total",
  TOTAL_AMOUNT: "Total",
  TOTAL_APPROVED: "Total Aprovado",
  TOTAL_APPROVED_CLAIM_VALUE: "Total Valor Garantia aprovado",
  TOTAL_APPROVED_INCLUDING_TAXES: "Total valor aprovado com Impostos",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Total Aprovado sem aditivos",
  TOTAL_CONTRIBUTION: "Contribui\xE7\xE3o total",
  TOTAL_REIMBURSED: "Reembolsado Totalmente",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Reembolso total ({currency})",
  TOTAL_REQUESTED: "Total Solicitado",
  TOTAL_REQUESTED_CLAIM_VALUE: " Valor Total de Garantia Solicitado",
  TOTAL_UNPAID: "Total N\xE3o Pago",
  TRACKING_NUMBER: "N\xFAmero de Rastreamento",
  TRANSFER: "Transferir",
  TRANSFER_APPROVALS: "Aprova\xE7\xF5es de Transfer\xEAncia",
  TRANSFER_APPROVALS_TAB: "Aprova\xE7\xF5es de Transfer\xEAncia ({count})",
  TRANSFER_CREATED: "Transfer\xEAncia Criada",
  TRANSFER_DEALER_RECOMMENDATIONS: "Tem certeza de que deseja transferir o pino para outro concession\xE1rio?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Transfer\xEAncia atualizada com \xEAxito",
  TRANSFERS: "Transfer\xEAncias",
  TRAVEL: "Deslocamento",
  TURKISH: "Turco",
  TWO_PERCENT_WITHHOLD_VALUE: "2% reter o valor",
  TYPE: "Tipo",
  TYPES: "Tipos",
  UNABLE_TO_CONTACT_THE_SERVER: "N\xE3o foi poss\xEDvel entrar em contato com o servidor",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "N\xE3o foi poss\xEDvel carregar os detalhes do cliente",
  UNDO: "Desfazer",
  UNDO_REGISTRATION: "Desfazer Registro",
  UNDO_REGISTRATION_SUCCESSFULL: "Registro de Desfazer Bem-sucedido",
  UNIT: "Unidade",
  UNIT_1: "Unidade 1",
  UNIT_2: "Unidade 2",
  UNIT_3: "Unidade 3",
  UNIT_OF_MEASURE: "Unidade de Medida",
  UNPAID_LABOR: "M\xE3o de Obra N\xE3o Paga",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Complementos de m\xE3o de obra n\xE3o pagos - Excluindo PIP",
  UNPAID_LABOR_ADDITIVES_PIPS: "Complementos de m\xE3o de obra n\xE3o pagos - PIP",
  UNPAID_OTHER_CREDITS: "Outros Cr\xE9ditos n\xE3o Pagos",
  UNPAID_PARTS: "Pe\xE7as N\xE3o Pagas",
  UNPAID_PARTS_ADDITIVE: "O Aditivo de Pe\xE7as n\xE3o pagas",
  UNPAID_TRAVEL: "Viagem n\xE3o Paga",
  UNSUB: "Editar",
  UNSUBMIT_CLAIM: "Editar Solicita\xE7\xE3o",
  UPDATE_CUSTOMER_INFORMATION: "Informa\xE7\xE3o Nova do Cliente",
  UPDATE_LABOR_RATES: "Atualizar taxas de m\xE3o de obra",
  UPDATE_LAYOUT: "Layout de atualiza\xE7\xE3o",
  UPDATE_MACHINE_STATUS: "Atualize o status da M\xE1quina",
  UPDATE_MACHINE_STATUS_HISTORY: "Atualizar Hist\xF3rico de Status da M\xE1quina",
  UPDATE_REGISTRATION: "Atualizar Registro",
  UPDATE_SELECTED: "Atualiza\xE7\xE3o Selecionada",
  UPDATED: "Atualizado",
  UPDATED_BY: "Atualizado por",
  UPLOAD_DOCUMENT: "Carregar documento",
  UPTIME_ASSURANCE: "Garantia de Tempo de Atividade",
  USEFUL_LINKS: "HiperLinkss \xDAteis",
  USER: "usu\xE1rio",
  USER_PREFERENCES_UPDATED: "Prefer\xEAncias do usu\xE1rio atualizadas",
  USER_SELECTED: "Selecionado pelo utilizador",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Reclama\xE7\xF5es selecionadas pelo utilizador ({count})",
  USERS_INFORMATION: "Informa\xE7\xF5es do Usu\xE1rio",
  VALIDATE: "Validar",
  VALIDATE_CLAIM: "Validar Solicita\xE7\xE3o",
  VALUE: "Valor",
  VALUE_OF_REPAIR: "Valor da repara\xE7\xE3o",
  VIEW_CLAIM: "Ver Solicita\xE7\xE3o",
  VIEW_DETAILS: "Exibir detalhes",
  VIEW_OPEN_PIPS: "Visualizar PIPs Abertos",
  VIEW_PIP: "Exibir PIP",
  VIEW_PRODUCTS: "Visualizar Produtos",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "Ver produtos e Atualizar informa\xE7\xE3o",
  VIEW_UPDATE: "Ver/atualizar",
  VSR_MESSAGES: "Mensagens VSR",
  WAITING_FOR_DLR_INV: "Esperando Fatura do Concession\xE1rio",
  WAITING_FOR_INVOICE: "A Aguardar Fatura ({count})",
  WAITING_SINCE: "Aguardando Desde",
  WARNING_MESSAGE_TITLE: "Foi enviada uma advert\xEAncia:",
  WARNING_MESSAGES: "Mensagens de advert\xEAncia",
  WARNING_MESSAGES_TITLE: "Foram enviadas v\xE1rias advert\xEAncias:",
  WARRANTY: "Garantias",
  WARRANTY_ADMIN: "Admin de Garantia",
  WARRANTY_CLAIM_TYPE: "Tipo de Reclama\xE7\xE3o de Garantia",
  WARRANTY_COVERAGE: "Cobertura da Garantia",
  WARRANTY_EXPIRATION: "T\xE9rmino da Garantia",
  WARRANTY_TYPE: "Tipo de Garantia",
  WARRANTY_TYPES: "Tipos de Garantias",
  WEAR_PARTS: "Pe\xE7as de Desgaste",
  WEAR_PARTS_COVERAGE: "Cobertura de Pe\xE7as de Desgaste",
  WELCOME: "Bem Vindo",
  WIP: "Trabalho em andamento",
  WITH_ADDITIVES: "Com Complementos/Aditivos",
  WITNESS_FIRST_NAME: "Nome da Testemunha",
  WITNESS_LAST_NAME: "Sobrenome da Testemunha",
  WORK_ORDER: "Ordem de Trabalho",
  WORK_ORDER_NUMBER: "N\xFAmero da ordem de servi\xE7o",
  WORK_ORDER_ONE: "Ordem de Servi\xE7o 1",
  WORK_ORDER_ONE_IS_REQUIRED: "\xC9 necess\xE1ria a ordem de servi\xE7o 1",
  WORK_ORDER_THREE: "Ordem de servi\xE7o 3",
  WORK_ORDER_THREE_IS_REQUIRED: "\xC9 necess\xE1ria a ordem de servi\xE7o 3",
  WORK_ORDER_TWO: "Ordem de Servi\xE7o 2",
  WORK_REPAIR_ORDER: "Ordem de servi\xE7o de repara\xE7\xE3o",
  YES: "Sim",
  YES_LOWERCASE: "Sim"
});